// If this code works, it was written by Romain Beaussart.
// If not, I don't know who wrote it ... (probably Maxime...)

import _ from "lodash";
import moment from "moment";

import csvtojson from "csvtojson";

import { formatCurrency, isAccountingZero, checkAmount, checkInt } from "../services/mathServices"; //! ok pour isAccounting mais formatCurrency varie légèrement entre front & back

// import { getRootName, isGeneralAccountableAccount, getVatRateSuffix } from "../accountableAccount/accountableAccountServices";
import {
    getRootName,
    isGeneralAccountableAccount,
} from "../accountableAccount/accountableAccountServices";
import {
    getAANameFromVatRate,
    getAANameFromVatType,
    getDefaultDedVatAAName,
    getDefaultFixedAssetsVatAAName,
    getDefaultPurchasesImportCollVatAAName,
    getDefaultPurchasesIntracomDedVatAAName,
    getDefaultPurchasesReverseChargeCollVatAAName,
    getDefaultPurchasesReverseChargeDedVatAAName,
} from "../vat/vatServices";
import { ImportSilae } from "./importSilae";

// import generalAccountableAccountTable from "../assets/fec/generalAccountableAccountTable.json";

const pattern = /(0{1,})$/;
const dateFrPattern = /^([0-9]{1,2})[-\/]([0-9]{1,2})[-\/]([0-9]{4})$/;
const dateEnPattern = /^([0-9]{4})[-\/]([0-9]{1,2})[-\/]([0-9]{1,2})$/;

// const integerPattern = /^[0-9]{1,}$/;
// const floatPattern = /^[0-9]{1,}[.,][0-9]{1,}$/;

// const vatRates = [20, 2.1, 5.5, 8.5, 10];

const formats = {
    fec: {
        columns: [
            { name: "JournalCode", fec: "JournalCode", mandatory: true },
            { name: "JournalLib", fec: "JournalLib", mandatory: true },
            { name: "EcritureNum", fec: "EcritureNum", mandatory: true },
            { name: "EcritureDate", fec: "EcritureDate", mandatory: true },
            { name: "CompteNum", fec: "CompteNum", mandatory: true },
            { name: "CompteLib", fec: "CompteLib", mandatory: true },
            { name: "CompAuxNum", fec: "CompAuxNum", mandatory: true },
            { name: "CompAuxLib", fec: "CompAuxLib", mandatory: true },
            { name: "PieceRef", fec: "PieceRef", mandatory: true },
            { name: "PieceDate", fec: "PieceDate", mandatory: true },
            { name: "EcritureLib", fec: "EcritureLib", mandatory: true },
            { name: "Debit", fec: "Debit", mandatory: true },
            { name: "Credit", fec: "Credit", mandatory: true },
            { name: "EcritureLet", fec: "EcritureLet", mandatory: true },
            { name: "DateLet", fec: "DateLet", mandatory: true },
            { name: "ValidDate", fec: "ValidDate", mandatory: true },
            { name: "AttachmentsInfo", fec: "fileName", mandatory: false },
            { name: "PieceUrl", fec: "url", mandatory: false },
        ],
    },
    // bobbee: {
    //     columns: [
    //         { name: "type", fec: "type", mandatory: false },
    //         { name: "log", fec: "JournalCode", mandatory: false },
    //         { name: "id", fec: "EcritureNum", mandatory: false },
    //         { name: "aaName", fec: "CompteNum", mandatory: true },
    //         { name: "aaWording", fec: "CompteLib", mandatory: false },
    //         { name: "invoiceNumber", fec: "PieceRef", mandatory: false },
    //         { name: "fileName", fec: "fileName", mandatory: false },
    //         { name: "url", fec: "url", mandatory: false },
    //         { name: "date", fec: "PieceDate", mandatory: true },
    //         { name: "wording", fec: "EcritureLib", mandatory: true },
    //         { name: "debit", fec: "Debit", mandatory: true },
    //         { name: "credit", fec: "Credit", mandatory: true },
    //         { name: "thirdPartyCompany", fec: "CompAuxLib", mandatory: false },
    //         { name: "firstname", fec: "firstname", mandatory: false },
    //         { name: "lastname", fec: "lastname", mandatory: false },
    //         { name: "user", fec: "user", mandatory: false },
    //         { name: "thirdParty", fec: "thirdParty", mandatory: false },
    //         { name: "tag1", fec: "tag1", mandatory: false },
    //         { name: "tag2", fec: "tag2", mandatory: false },
    //         { name: "tag3", fec: "tag3", mandatory: false },
    //         { name: "tag4", fec: "tag4", mandatory: false }
    //     ]
    // },
    // evoliz: {
    //     columns: [
    //         { name: "N° de ligne", fec: "EcritureNum", mandatory: true },
    //         { name: "Date de pièce", fec: "PieceDate", mandatory: true },
    //         { name: "Code journal", fec: "JournalCode", mandatory: true },
    //         { name: "Numéro de compte", fec: "CompteNum", mandatory: true },
    //         { name: "Numéro de pièce", fec: "PieceRef", mandatory: true },
    //         { name: "Libellé compte auxiliaire", fec: "EcritureLib", mandatory: true }, // fec: "CompAuxLib",  },
    //         { name: "Débit", fec: "Debit", mandatory: true },
    //         { name: "Crédit", fec: "Credit", mandatory: true },
    //         { name: "Lien document", fec: "url", mandatory: false },
    //         { name: "Mode de règlement", fec: "CompAuxLib", mandatory: false }, // fec: "paymentType", }
    //     ]
    // },
    // Date du paiement	intitulé du compte	JNAL	Compte	 PIECES / FACTURE	Libelles	Débit	Crédit	Monnaie	Axe 1 	Axe 2	Nom du/des reçu(s)
    // spendesk: {
    //     columns: [
    //         { name: "Numéro de pièce", fec: "EcritureNum", mandatory: false },
    //         { name: "Date du paiement", fec: "PieceDate", mandatory: true },
    //         { name: "intitulé du compte", fec: "thirdParty", mandatory: true },
    //         { name: "JNAL", fec: "JournalCode", mandatory: true },
    //         { name: "Compte", fec: "CompteNum", mandatory: true },
    //         { name: "PIECES / FACTURE", fec: "PieceRef", mandatory: false },
    //         { name: "Numéro de facture", fec: "PieceRef", mandatory: false },
    //         { name: "Numéro de note de frais", fec: "PieceRef", mandatory: false },
    //         { name: "Libelles", fec: "EcritureLib", mandatory: true },
    //         { name: "Débit", fec: "Debit", mandatory: true },
    //         { name: "Crédit", fec: "Credit", mandatory: true },
    //         { name: "Nom du/des reçu(s)", fec: "fileName", mandatory: false },
    //         { name: "Axe 1", fec: "tag1", mandatory: false },
    //         { name: "Axe 2", fec: "tag2", mandatory: false }
    //     ]
    // }
};

export abstract class ImportFecBase {
    salesAccounts = [];
    managedTypes = [
        "PURCHASE_INVOICE",
        "CURRENT_ACCOUNT",
        "OPERATOR_ACCOUNT",
        "EXPENSE_REPORT",
        "PAY_SLIP",
        "SALES_INVOICE",
        "ZTILL_RECEIPT",
        "MISCELLANEOUS_OPERATION",
        "VAT",
        "CARRY_FORWARD",
        "BANK_TRANSACTION",
        "BANK_TRANSACTION & PURCHASE_INVOICE",
        "BANK_TRANSACTION & EXPENSE_REPORT",
        "BANK_TRANSACTION & CURRENT_ACCOUNT",
        "BANK_TRANSACTION & OPERATOR_ACCOUNT",
        "BANK_TRANSACTION & COMMISSION",
        "BANK_TRANSACTION & LOAN",
        "BANK_TRANSACTION & WITH_DELTA",
        "BANK_TRANSACTION & SALES_INVOICE",
        "BANK_TRANSACTION & ZTILL_RECEIPT",
        "BANK_TRANSACTION & MISCELLANEOUS_OPERATION",
        "WITH_DELTA",
    ];

    //
    // pourquoi pas le 703 ?
    //
    managedSalesAccounts = ["701", "702", "704", "705", "706", "707", "708", "709"];

    commissionAAs = ["627000", "627100", "627200", "627800", "445660"];

    toValidateAAs = ["401000", "411000", "411100", "411200", "411700", "421000", "425000"];
    //
    // bankAccounts = []
    // users = []
    // companies = []
    accountingItems = [];
    reconciliations = [];
    importTitle = "";
    companyId = "";
    vats = {
        accountableAccounts: [],
        debit: 0.0,
        credit: 0.0,
        amountSigned: 0.0,
    };

    carryForwards;

    accountableAccounts: Array<any>;

    accountingItemImport: any;

    withAccountingItemImport: boolean = true;

    accountingPeriod: any = null;

    importCarryForward: boolean = true;

    accountingFirmId: "";
    useAccountingFirmAccountableAccountMapping: boolean = false;
    accountingFirmAccountableAccountMappings = {};

    repair: boolean = false;

    logs = [];

    totalDebitCredit: number = 0;
    containsNotBalancesTransactions: boolean = false;

    constructor(
        companyId: string,
        withAccountingItemImport: boolean = true,
        repair: boolean = false
    ) {
        this.companyId = companyId;
        this.withAccountingItemImport = withAccountingItemImport;
        this.repair = repair;

        this.reset();
    }

    abstract getVatAAsQuery();

    // get rules() {
    //     return rules
    // }

    // get generalAccountableAccountTable() {
    //     return generalAccountableAccountTable;
    // }

    get isEditable() {
        if (!this.accountingItemImport) return true;
        if (this.accountingItemImport.status === "EDITION") {
            return true;
        }
        if (this.repair) {
            return true;
        }
        return false;
    }

    containsCarryForward() {
        for (const accountingItem of this.accountingItems) {
            if (accountingItem.type === "CARRY_FORWARD") {
                return true;
            }
        }
        return false;
    }

    bankAccounts = [];
    users = [];
    companies = [];

    setAccountingFirm(accountingFirmId) {
        this.accountingFirmId = accountingFirmId;
    }

    setAccountableAccountMappings(aams) {
        this.accountingFirmAccountableAccountMappings = {};
        for (const aam of aams) {
            this.accountingFirmAccountableAccountMappings[aam.name] = aam;
        }
    }

    isGeneralAccountableAccount(accountableAccount) {
        return isGeneralAccountableAccount(accountableAccount);
    }

    setAccountingPeriod(accountingPeriod) {
        this.accountingPeriod = accountingPeriod;
        this.accountingPeriod.mStart = moment(this.accountingPeriod.start).startOf("day");
        this.accountingPeriod.mEnd = moment(this.accountingPeriod.end).endOf("day");
        this.analyseAllRowErrors();
    }

    analyseAllRowErrors() {
        for (const accountingItem of this.accountingItems) {
            accountingItem.errorCount = 0;
            for (const row of accountingItem.rows) {
                row.dateError = "";
                row.debitError = "";
                row.creditError = "";
                row.wordingError = "";
                row.typeError = "";
                row.accountableAccountError = "";
                this.analyseRowErrors(accountingItem, row);
            }

            // compute availableDates if necessary to allow user correction
            if (accountingItem.datesAreDifferent || accountingItem.datesAreBeforePeriod) {
                accountingItem.availableDates = [];
                accountingItem.selectedDate = "";
                for (const row of accountingItem.rows) {
                    if (
                        !this.accountingPeriod ||
                        moment(row.date, "YYYYMMDD").isSameOrAfter(this.accountingPeriod.mStart)
                    ) {
                        if (accountingItem.availableDates.indexOf(row.date) === -1) {
                            accountingItem.availableDates.push(row.date);
                        }
                    }
                }
            } else if (accountingItem.type === "CARRY_FORWARD") {
                if (this.accountingPeriod?.mStart) {
                    accountingItem.date = this.accountingPeriod.mStart.format("YYYY-MM-DD");
                }
            }
        }
    }

    analyseRowErrors(accountingItem, row) {
        if (row.id === "ORPHELIN") {
            accountingItem.errorCount++;
        }
        //
        // date
        //
        if (!row.date) {
            accountingItem.errorCount++;
            row.dateError = "Not Defined";
        } else if (!checkInt(row.date)) {
            accountingItem.errorCount++;
            row.dateError = "Wrong format";
        } else if (row.date.length !== 8) {
            accountingItem.errorCount++;
            row.dateError = "Wrong format";
        } else {
            const rowDate = moment(row.date, "YYYYMMDD").utc(true);
            if (this.accountingPeriod && rowDate.isBefore(moment(this.accountingPeriod.start))) {
                if (accountingItem.type !== "CARRY_FORWARD") {
                    accountingItem.errorCount++;
                    row.dateError =
                        (row.dateError ? row.dateError + " | " : "") +
                        "La date est antérieure à l'exercice";
                    accountingItem.datesAreBeforePeriod = true;
                    accountingItem.compatibleTypes = [
                        {
                            value: accountingItem.type,
                            text: accountingItem.type,
                        },
                        {
                            value: "CARRY_FORWARD",
                            text: "CARRY_FORWARD",
                        },
                    ];
                }
                // else {
                //     accountingItem.warningCount++;
                //     row.dateWarning = (row.dateWarning ? row.dateWarning + " | " : "") + "Date is before period";
                // }
            } else if (
                this.accountingPeriod &&
                rowDate.isAfter(moment(this.accountingPeriod.end))
            ) {
                accountingItem.errorCount++;
                row.dateError =
                    (row.dateError ? row.dateError + " | " : "") + "La date est après à l'exercice";
            }
            if (
                /*!accountingItem.datesAreBeforePeriod &&*/ row.type.startsWith("BANK_TRANSACTION")
            ) {
                // debugger
                const lastDate = this.bankAccounts.find(
                    (ba) => ba.name === row.bankAccount
                )?.lastDate;
                if (lastDate && rowDate.isBefore(moment(lastDate))) {
                    accountingItem.errorCount++;
                    row.dateError =
                        (row.dateError ? row.dateError + " | " : "") +
                        "La date est avant la date de clôture des flux";
                }
            }
            if (!accountingItem.datesAreBeforePeriod && row.date !== accountingItem.originalDate) {
                if (
                    accountingItem.type !== "CARRY_FORWARD" &&
                    accountingItem.type !== "MISCELLANEOUS_OPERATION"
                ) {
                    accountingItem.errorCount++;
                    row.dateError = "Les dates sont différentes";
                    accountingItem.datesAreDifferent = true;
                }
                // else {
                //     accountingItem.warningCount++;
                //     row.dateWarning = "Date is different";
                // }
            }
        }

        if (row.date && !accountingItem.date) {
            const rowDate = moment(row.date, "YYYYMMDD").utc(true);
            accountingItem.mDate = rowDate;
            accountingItem.date = accountingItem.mDate.format("YYYY-MM-DD");
        }
        //
        // wording
        //
        if (!row.wording) {
            accountingItem.errorCount++;
            row.wordingError = "Non défini";
        }
        //
        // type
        //
        if (!row.type) {
            accountingItem.errorCount++;
            row.typeError = "Not Defined";
        } else {
            if (row.type !== accountingItem.type) {
                accountingItem.errorCount++;
                row.typeError = "Different from accountingItem type";
            }
        }
        // accountableAccount
        if (!row.accountableAccount) {
            accountingItem.status = false;
            accountingItem.errorCount++;
            row.accountableAccountError = "Not Defined";
            // return;
        }
        // debit
        if (row.debit) {
            if (!this.checkAmount(row.debit)) {
                accountingItem.errorCount++;
                row.debitError = "Wrong format";
            } else {
                row.result.debit = parseFloat(row.debit);
                if (row.result.debit < 0) {
                    row.credit = (-row.result.debit).toString();
                    row.result.credit = -row.result.debit;
                    row.debit = "0";
                    row.result.debit = 0.0;
                }
            }
        }
        // credit
        if (row.credit) {
            if (!this.checkAmount(row.credit)) {
                accountingItem.errorCount++;
                row.creditError = "Wrong format";
            } else {
                row.result.credit = parseFloat(row.credit);
                if (row.result.credit < 0) {
                    row.debit = (-row.result.credit).toString();
                    row.result.debit = -row.result.credit;
                    row.credit = "0";
                    row.result.credit = 0.0;
                }
            }
        }
    }

    get containsDateDifferenceErrors() {
        for (const accountingItem of this.accountingItems) {
            if (accountingItem.datesAreDifferent) {
                return true;
            }
        }
        return false;
    }

    correctDateDifferenceErrors() {
        for (const accountingItem of this.accountingItems) {
            if (accountingItem.datesAreDifferent) {
                let maxDate;
                for (const date of accountingItem.availableDates) {
                    if (!maxDate) maxDate = date;
                    else if (maxDate < date) maxDate = date;
                }
                accountingItem.selectedDate = maxDate;
                this.onAccountingItemDateChanged(accountingItem);
            }
        }
    }

    onAccountingItemDateChanged(accountingItem) {
        if (accountingItem.selectedDate) {
            accountingItem.originalDate = accountingItem.selectedDate;
            accountingItem.mDate = moment(accountingItem.originalDate, "YYYYMMDD");
            accountingItem.date = accountingItem.mDate.format("YYYY-MM-DD");
            for (const row of accountingItem.rows) {
                row.date = accountingItem.selectedDate;
                if (row.dateError) {
                    delete row.dateError;
                    accountingItem.errorCount--;
                }
            }
        }
    }

    onAccountingItemTypeChanged(accountingItem) {
        // console.error(accountingItem);
        // debugger;
        if (accountingItem.type === "CARRY_FORWARD") {
            for (const row of accountingItem.rows) {
                row.type = accountingItem.type;
                if (row.dateError) {
                    delete row.dateError;
                    accountingItem.errorCount--;
                }
            }
        }
        //  else {
        //     for (const row of accountingItem.rows) {
        //         row.type = accountingItem.type
        //         row.dateError = ""
        //         accountingItem.errorCount++
        //     }
        // }
    }

    analyseAccountingItem(accountingItem) {
        if (!accountingItem.date) {
            accountingItem.mDate = moment(accountingItem.originalDate, "YYYYMMDD");
            accountingItem.date = accountingItem.mDate.format("YYYY-MM-DD");
        }

        accountingItem.totalDebit = 0.0;
        accountingItem.totalCredit = 0.0;
        for (const row of accountingItem.rows) {
            accountingItem.totalDebit += row.result.debit;
            accountingItem.totalCredit += row.result.credit;
        }
        accountingItem.difference =
            Math.round(Math.abs(accountingItem.totalCredit - accountingItem.totalDebit) * 100) /
            100;
        if (accountingItem.difference) {
            accountingItem.errorCount++;
            accountingItem.differenceError = "Interdit";
        }
        // this.checkSales(accountingItem)
    }

    checkAmount(x) {
        return checkAmount(x);
    }

    identifySalesAccounts(accountableAccount) {
        if (accountableAccount && accountableAccount.startsWith("70")) {
            const rootAA = accountableAccount.substring(0, 3);
            if (
                this.managedSalesAccounts.indexOf(rootAA) !== -1 &&
                this.salesAccounts.indexOf(rootAA) === -1
            ) {
                this.salesAccounts.push(rootAA);
            }
        }
    }

    addRowToAccountingItem(dicoAccountingItems, row, transactionIndex, tags = undefined) {
        let accountingItem = dicoAccountingItems[row.id];
        if (!accountingItem) {
            accountingItem = {
                transactionIndex,
                index: row.id,
                logCode: row.logCode,
                originalDate: row.date,
                type: row.type,
                wording: row.wording,
                dueDate: row.dueDate,
                rows: [row],
                errorCount: 0,
                warningCount: 0,
                autoLetteringCount: 0,
                totalDebit: 0.0,
                totalCredit: 0.0,
                difference: 0.0,
                tags,
            };
            if (this.managedTypes.indexOf(row.type) === -1) {
                accountingItem.errorCount++;
                accountingItem.typeError = "Type not implemented";
            }
            dicoAccountingItems[row.id] = accountingItem;
            this.accountingItems.push(accountingItem);
        } else {
            accountingItem.rows.push(row);
        }
        return accountingItem;
    }

    computeReconciliations() {
        if (!this.data || !this.dbAccountableAccounts) {
            return;
        }
        this.reconciliations = [];
        const thirdParties = {};
        // const dicoOrphelins = {}
        // for (const accountingItem of this.accountingItems) {
        for (let index = 0; index < this.accountingItems.length; index++) {
            const accountingItem = this.accountingItems[index];
            for (const row of accountingItem.rows) {
                const dbAA = this.dbAccountableAccounts.find(
                    (aa) => aa.name === row.accountableAccount
                );
                // const rule = this.rules.accountableAccounts[parseInt(row.accountableAccount, 10)];
                if (!dbAA) {
                    console.error("ERROR rule not found for= " + row.accountableAccount);
                    debugger;
                    continue;
                }

                if (!dbAA.lettering) {
                    continue;
                }

                if (row.accountableAccount) {
                    let key = row.originalAccountableAccount + "_" + row.accountableAccount;
                    if ((dbAA && dbAA.thirdPartyCompany) || dbAA.user) {
                        if (row.thirdPartyCompany) {
                            key += " - " + row.thirdPartyCompany;
                        } else if (row.user) {
                            key += " - " + row.user;
                        } else {
                            debugger;
                        }
                    }
                    let thirdParty = thirdParties[key];
                    if (!thirdParty) {
                        thirdParty = {
                            letterings: {},
                            orphelinRows: [],
                            orphelinTotalAmountSigned: 0.0,
                        };
                        thirdParties[key] = thirdParty;
                    }
                    if (row.lettering) {
                        // key += " - " + row.lettering
                        let letterings = thirdParty.letterings[row.lettering];
                        if (!letterings) {
                            letterings = [];
                            thirdParty.letterings[row.lettering] = letterings;
                        }
                        letterings.push({
                            ai: accountingItem,
                            aiIndex: index,
                            row: row,
                        });
                    } else {
                        thirdParty.orphelinRows.push({
                            accountingItem,
                            row,
                        });
                        thirdParty.orphelinTotalAmountSigned +=
                            row.result.debit - row.result.credit;
                        // accountingItem.letteringMissing = true
                        // row.letteringMissing = true
                    }
                } else {
                    debugger;
                }
            }
        }
        // ----------------
        // reconciliation -
        // ----------------
        // const dicoAIReconciliations = {}
        for (const recKey in thirdParties) {
            const thirdParty = thirdParties[recKey];
            for (const key in thirdParty.letterings) {
                const letterings = thirdParty.letterings[key];

                if (letterings.length > 1) {
                    const reconciliation = {
                        type: "DEFAULT",
                        status: "VALIDATED",
                        index: this.reconciliations.length,
                        debit: 0.0,
                        credit: 0.0,
                        letterings: [],
                    };
                    this.reconciliations.push(reconciliation);
                    for (const item of letterings) {
                        // const itemReconciliation = dicoAIReconciliations[item.aiIndex];
                        // if (!itemReconciliation) {
                        //     dicoAIReconciliations[item.aiIndex] = reconciliation
                        // } else if (itemReconciliation !== reconciliation) {
                        //     debugger;
                        // }

                        if (item.row.reconciliationIndex !== undefined) {
                            debugger;
                        }
                        item.row.reconciliationIndex = reconciliation.index;
                        reconciliation.debit += item.row.result.debit;
                        reconciliation.credit += item.row.result.credit;
                        reconciliation.letterings.push(item);
                    }
                } else if (letterings.length === 1) {
                    thirdParty.orphelinRows.push({
                        accountingItem: letterings[0].ai,
                        row: letterings[0].row,
                    });
                    letterings.splice(0, 1);
                    // debugger
                }
            }
            //
            // remove unbalanced reconciliation
            //
            for (let index = this.reconciliations.length - 1; index >= 0; index--) {
                const reconciliation = this.reconciliations[index];
                if (Math.abs(reconciliation.debit - reconciliation.credit) >= 1e-2) {
                    console.error(
                        "status reconciliation non équilibré écart= " +
                            (reconciliation.debit - reconciliation.credit)
                    );
                    thirdParty.orphelinTotalAmountSigned +=
                        reconciliation.debit - reconciliation.credit;
                    for (const item of reconciliation.letterings) {
                        thirdParty.orphelinRows.push({
                            accountingItem: item.ai,
                            row: item.row,
                        });
                    }
                    for (const item of reconciliation.letterings) {
                        if (item.row.reconciliationIndex !== undefined) {
                            delete item.row.reconciliationIndex;
                        }
                    }
                    this.reconciliations.splice(index, 1);
                    // debugger
                }
            }
            //
            // add reconciliation auto
            //
            if (
                thirdParty.orphelinRows.length &&
                Math.abs(thirdParty.orphelinTotalAmountSigned) < 1e-3
            ) {
                if (thirdParty.orphelinRows.length > 1) {
                    const reconciliation = {
                        type: "DEFAULT",
                        status: "VALIDATED",
                        index: this.reconciliations.length,
                        debit: 0.0,
                        credit: 0.0,
                    };
                    this.reconciliations.push(reconciliation);
                    for (const orphelin of thirdParty.orphelinRows) {
                        if (orphelin.row) {
                            orphelin.row.reconciliationIndex = reconciliation.index;
                            orphelin.row.lettering = "Auto";
                            orphelin.accountingItem.autoLetteringCount++;
                        } else {
                            debugger;
                        }
                        // reconciliation.debit += row.result.debit
                        // reconciliation.credit += row.result.credit
                    }
                } else {
                    debugger;
                }
            }
            //
            // DO NOT CHANGER ORDER
            // remove reconciliation linked with CARRY_FORWARD if no importCarryForward
            //
            if (!this.importCarryForward) {
                for (let index = this.reconciliations.length - 1; index >= 0; index--) {
                    const reconciliation = this.reconciliations[index];
                    // if (Math.abs(reconciliation.debit - reconciliation.credit) >= 1.e-2) {
                    if (reconciliation.letterings?.find((l) => l.ai.type === "CARRY_FORWARD")) {
                        // thirdParty.orphelinTotalAmountSigned += reconciliation.debit - reconciliation.credit
                        // for (const item of reconciliation.letterings) {
                        //     thirdParty.orphelinRows.push({
                        //         accountingItem: item.ai,
                        //         row: item.row
                        //     })
                        // }
                        for (const item of reconciliation.letterings) {
                            if (item.row.reconciliationIndex !== undefined) {
                                delete item.row.reconciliationIndex;
                            }
                        }
                        this.reconciliations.splice(index, 1);
                        // debugger
                    }
                }
            }
        }
    }

    // computeVAT() {
    //     if (!this.accountingPeriod) {
    //         return;
    //     }
    //     if (!this.importCarryForward) {
    //         return;
    //     }
    //     this.vats = {
    //         accountableAccounts: [],
    //         debit: 0.0,
    //         credit: 0.0,
    //         amountSigned: 0.0,
    //     };
    //     // let endDate = ""
    //     for (const accountingItem of this.accountingItems) {
    //         // if (!endDate) {
    //         //     endDate = accountingItem.originalDate
    //         // } else if (endDate < accountingItem.originalDate) {
    //         //     endDate = accountingItem.originalDate
    //         // }
    //         // let grossAmountFounded = false
    //         for (const row of accountingItem.rows) {
    //             if (row.accountableAccount.startsWith("445")) {
    //                 // const rule = this.rules.rules[row.accountableAccount];
    //                 // if (rule.grossAmount) {
    //                 //     grossAmountFounded = true
    //                 // }
    //                 accountingItem.vatDeclarationDone = true;
    //                 let aaData = this.vats.accountableAccounts.find(
    //                     (aa) => aa.accountableAccount === row.accountableAccount
    //                 );
    //                 if (!aaData) {
    //                     aaData = {
    //                         accountableAccount: row.accountableAccount,
    //                         amountSigned: 0.0,
    //                     };
    //                     this.vats.accountableAccounts.push(aaData);
    //                 }
    //                 aaData.amountSigned += row.result.debit - row.result.credit;
    //             }
    //         }
    //         // if (accountingItem.vatDeclaration && grossAmountFounded) {
    //         // }
    //     }
    //     for (const aaData of this.vats.accountableAccounts) {
    //         aaData.debit = aaData.amountSigned > 0 ? aaData.amountSigned : 0.0;
    //         aaData.credit = aaData.amountSigned < 0 ? -aaData.amountSigned : 0.0;
    //         this.vats.amountSigned += aaData.amountSigned;
    //     }
    //     this.vats.debit += this.vats.amountSigned > 0 ? this.vats.amountSigned : 0.0;
    //     this.vats.credit += this.vats.amountSigned < 0 ? -this.vats.amountSigned : 0.0;

    //     if (Math.abs(this.vats.amountSigned) > 1e-2) {
    //         const id = "Solde de TVA";
    //         let index = 0;
    //         const mdate = moment(this.accountingPeriod.end);
    //         const date = mdate.format("YYYYMMDD");
    //         let wording = "Solde de TVA  ";
    //         wording += mdate.format("YYYY");
    //         const rows = this.vats.accountableAccounts
    //             .filter((aaData) => Math.abs(aaData.debit - aaData.credit) > 1e-2)
    //             .map((aaData) => ({
    //                 id: id,
    //                 index: index++,
    //                 type: "MISCELLANEOUS_OPERATION",
    //                 wording: wording,
    //                 logCode: "OD",
    //                 originalAccountableAccount: "",
    //                 accountableAccount: aaData.accountableAccount,
    //                 date: date,
    //                 itemReference: "",
    //                 debit: aaData.debit.toString(),
    //                 credit: aaData.credit.toString(),
    //                 dueDate: null,
    //                 lettering: "",
    //                 result: {
    //                     debit: aaData.debit,
    //                     credit: aaData.credit,
    //                 },
    //                 otherAttributes: {},
    //             }));
    //         rows.push({
    //             id: id,
    //             index: index++,
    //             type: "MISCELLANEOUS_OPERATION",
    //             wording: wording,
    //             logCode: "OD",
    //             originalAccountableAccount: "",
    //             accountableAccount: "445510",
    //             date: date,
    //             itemReference: "",
    //             debit: this.vats.credit.toString(),
    //             credit: this.vats.debit.toString(),
    //             dueDate: null,
    //             lettering: "",
    //             result: {
    //                 debit: this.vats.credit,
    //                 credit: this.vats.debit,
    //             },
    //             otherAttributes: {},
    //         });
    //         const accountingItem = {
    //             transactionIndex: this.accountingItems.length,
    //             index: id,
    //             originalDate: date,
    //             type: "MISCELLANEOUS_OPERATION",
    //             wording: "Solde de TVA",
    //             rows: rows,
    //             errorCount: 0,
    //             warningCount: 0,
    //             autoLetteringCount: 0,
    //             totalDebit: 0.0,
    //             totalCredit: 0.0,
    //             difference: 0.0,
    //         };
    //         this.analyseAccountingItem(accountingItem);
    //         this.accountingItems.push(accountingItem);
    //     }
    // }

    isBTAndCommission(index, accountingItem, row1, row2, solution) {
        if (!row1.accountableAccount.startsWith("512")) return false;

        if (this.commissionAAs.indexOf(row2.accountableAccount) === -1) return false;
        if (row2.accountableAccount.startsWith("445660")) return false;

        solution.commissionIndex = index;
        solution.commissionAccountingItem = accountingItem;
        solution.commissionBt = row1;
        solution.commission = row2;
        return true;
    }

    isBTAndVAT(index, accountingItem, row1, row2, solution) {
        if (!row1.accountableAccount.startsWith("512")) return false;
        if (!row2.accountableAccount.startsWith("445660")) return false;

        solution.vatIndex = index;
        solution.vatAccountingItem = accountingItem;
        solution.vatBt = row1;
        solution.vat = row2;
        return true;
    }

    reduce() {
        const emptySolution = {
            commissionIndex: null,
            commissionAccountingItem: null,
            commissionBt: null,
            commission: null,
            vatIndex: null,
            vatAccountingItem: null,
            vatBt: null,
            vat: null,
        };

        let solution = JSON.parse(JSON.stringify(emptySolution));

        for (let index = 0; index < this.accountingItems.length; index++) {
            const accountingItem = this.accountingItems[index];

            if (accountingItem.rows.length === 2) {
                // if (accountingItem.rows[0].lettering || accountingItem.rows[1].lettering) {
                //     solution = JSON.parse(JSON.stringify(emptySolution));
                //     continue;
                // }
                if (solution.commissionAccountingItem) {
                    if (
                        solution.commissionAccountingItem.date !== accountingItem.date ||
                        solution.commissionAccountingItem.type !== accountingItem.type
                    ) {
                        solution = JSON.parse(JSON.stringify(emptySolution));
                        continue;
                    }
                }
                if (solution.vatAccountingItem) {
                    if (
                        solution.vatAccountingItem.date !== accountingItem.date ||
                        solution.vatAccountingItem.type !== accountingItem.type
                    ) {
                        solution = JSON.parse(JSON.stringify(emptySolution));
                        continue;
                    }
                }
                if (
                    !this.isBTAndCommission(
                        index,
                        accountingItem,
                        accountingItem.rows[0],
                        accountingItem.rows[1],
                        solution
                    )
                ) {
                    if (
                        !this.isBTAndCommission(
                            index,
                            accountingItem,
                            accountingItem.rows[1],
                            accountingItem.rows[0],
                            solution
                        )
                    ) {
                        if (
                            !this.isBTAndVAT(
                                index,
                                accountingItem,
                                accountingItem.rows[0],
                                accountingItem.rows[1],
                                solution
                            )
                        ) {
                            if (
                                !this.isBTAndVAT(
                                    index,
                                    accountingItem,
                                    accountingItem.rows[1],
                                    accountingItem.rows[0],
                                    solution
                                )
                            ) {
                                solution = JSON.parse(JSON.stringify(emptySolution));
                                continue;
                            }
                        }
                    }
                }
                if (solution.commissionAccountingItem && solution.vatAccountingItem) {
                    solution.commissionAccountingItem.rows.push(solution.vat);
                    solution.commissionBt.result.debit += solution.vatBt.result.debit;
                    solution.commissionBt.result.credit += solution.vatBt.result.credit;
                    solution.commissionBt.debit = solution.commissionBt.result.debit.toString();
                    solution.commissionBt.credit = solution.commissionBt.result.credit.toString();
                    this.accountingItems.splice(solution.vatIndex, 1);
                    index--;
                    solution = JSON.parse(JSON.stringify(emptySolution));
                }
            } else {
                solution = JSON.parse(JSON.stringify(emptySolution));
            }
        }
    }

    isValid() {
        if (this.totalDebitCredit) {
            return false;
        }
        if (this.containsNotBalancesTransactions) {
            return false;
        }
        if (!this.isEditable && !this.repair) {
            return false;
        }
        if (!this.accountingItems.length) return false;
        for (const aa of this.accountingItems) {
            if (aa.errorCount) return false;
        }
        if (this.containsCarryForward() && (!this.accountingPeriod || !this.accountingPeriod.id)) {
            return false;
        }
        return true;
    }

    getNewAccountingFirmAccountableAccountMappings() {
        const newAccountingFirmAccountableAccountMappings = [];
        if (this.useAccountingFirmAccountableAccountMapping && this.accountableAccounts) {
            for (const aa of this.accountableAccounts) {
                if (!aa.name || !aa.oss360AAName) {
                    // debugger;
                    continue;
                }

                if (this.isGeneralAccountableAccount(aa.name) && aa.isGeneral) {
                    continue;
                }
                if (this.accountingFirmAccountableAccountMappings[aa.name]) {
                    continue;
                }
                const aaMappging: any = {
                    originalName: aa.name,
                    originalDescription: aa.desc,
                    oss360AAName: aa.oss360AAName,
                };
                // if (!aa.disabledTag && aa.tag) {
                //     aaMappging.tag = aa.tag
                // }
                // data.accountableAccountMapping[aa.name] = aaMappging
                newAccountingFirmAccountableAccountMappings.push(aaMappging);
            }
        }
        return newAccountingFirmAccountableAccountMappings;
    }

    async import(companyId, updateSalesAccounts) {
        if (!this.isValid()) {
            debugger;
            return null;
        }
        if (this.withAccountingItemImport) {
            await this.upsertAccountingItemImport(companyId);
        }

        for (const user of this.users) {
            if (user.notExistingUser) {
                user.user.id = "";
            }
        }

        for (const ai of this.accountingItems) {
            if (ai.mDate) {
                delete ai.mDate;
            }
        }

        // const accountingItems = jsonpack.pack(JSON.stringify(this.accountingItems)) // WARNING : do not remove stringify
        this.computeReconciliations();
        const reconciliations = this.reconciliations.map((r) => {
            return {
                type: r.type,
                index: r.index,
                status: r.status,
            };
        });

        const logs = [];
        for (const log of this.logs) {
            logs.push({
                code: log.shortName,
                name: log.name,
                import: log.import,
                importName: log.importName,
            });
        }

        return await this.importEnd(companyId, logs, reconciliations, updateSalesAccounts);
    }

    abstract importEnd(companyId, logs, reconciliations, updateSalesAccounts);

    // async upsertAccountingItemImport(companyId) {}
    // }

    // export default class ImportFecBase extends AccountingItemImportBase {
    payslipOnly: boolean;
    sylae: boolean;
    forceAAIfNotFound: boolean = false;
    aaCharacterCount: number = 6;
    dbAccountableAccounts: Array<any>;
    inAccountableAccounts: Array<any>;
    defaultAccountableAccounts = {};
    closestAccountableAccounts = {};
    columnMapping = [];
    mappingSuggestions = null;
    data: Array<any>;
    journalCodes: Array<any>;
    file = undefined;
    zipFile = undefined;
    inputData: string;

    generalAAs = [[], [], [], [], [], [], []];

    purchaseAAs = [/^60/, /^61/, /^62/, /^63/, /^64/, /^20/, /^21/];

    typeRules = {
        BANK_TRANSACTION: {
            mandatory: [[/^512/]],
            excluded: [/^129/, /^120/],
        },
        PURCHASE_INVOICE: {
            mandatory: [this.purchaseAAs, [/^40[134]/, /^50/, /^53/]],
            optional: [/^4456/],
            excluded: [
                /^1/,
                /^41/,
                /^42/,
                /^43/,
                /^45/,
                /^46/,
                /^47/,
                /^48/,
                /^49/,
                /^511/,
                /^580/,
            ],
        },
        CURRENT_ACCOUNT: {
            mandatory: [this.purchaseAAs, [/^4550/, /^4551/]],
            optional: [/^4456/],
            excluded: [/^1/, /^401/, /^411/, /^512/],
        },
        OPERATOR_ACCOUNT: {
            mandatory: [this.purchaseAAs, [/^108/]],
            excluded: [/^1/, /^401/, /^411/, /^512/],
        },
        EXPENSE_REPORT: {
            mandatory: [this.purchaseAAs, [/^4671/, /^425/]], // - 40),
            optional: [/^4456/],
            excluded: [
                /^1/,
                /^41/,
                /^42/,
                /^43/,
                /^45/,
                /^46/,
                /^47/,
                /^48/,
                /^49/,
                /^511/,
                /^580/,
            ],
        },
        PAY_SLIP: {
            mandatory: [[/^64/], [/^42/]],
            // mandatory: [[/^64/], [/^42/ ,/^455/]],
            optional: [/^43/, /^44/, /^46/, /^62/, /^63/, /^658/, /^708/, /^758/],
            excluded: [/^1/, /^445/],
        },
        SALES_INVOICE: {
            mandatory: [[/^70[12456789]/, /^700000/], [/^411/]],
            optional: [/^4457/],
            excluded: [/^1/, /^511/, /^580/, /^455/, /^401/],
        },
        ZTILL_RECEIPT: {
            mandatory: [
                [/^70[12456789]/, /^700000/],
                [/^511/, /^53/, /^58/],
            ],
            optional: [/^4457/],
            excluded: [/^1/, /^401/],
        },
        VAT: {
            mandatory: [[/^445510/, /^445670/], [/^445/]],
            // excluded: [/^/]
            excluded: [
                /^1/,
                /^2/,
                /^3/,
                /^41/,
                /^42/,
                /^43/,
                /^440/,
                /^441/,
                /^442/,
                /^443/,
                /^444/,
                /^446/,
                /^447/,
                /^448/,
                /^449/,
                /^45/,
                /^46/,
                /^47/,
                /^48/,
                /^49/,
                /^5/,
                /^6/,
                /^7/,
            ],
        },
        CARRY_FORWARD: {
            mandatory: [[/^110/, /^119/, /^120/, /^129/, /^8/], [/^[^6-7]/]],
            excluded: [/^[6-7]/],
        },
        // CASH_BOX: [[/^531000/]], // , -> 58 ou 41),
        // MISCELLANEOUS_OPERATION: []
    };

    // allAccounts = {
    //     CARRY_FORWARD: /^[^6-7]/
    // }

    priorityTypes = {
        BANK_TRANSACTION: ["PAY_SLIP", "EXPENSE_REPORT"],
        // CASH_BOX: ["PAY_SLIP", "EXPENSE_REPORT"],
        CURRENT_ACCOUNT: ["PURCHASE_INVOICE"],
        OPERATOR_ACCOUNT: ["PURCHASE_INVOICE"],
        EXPENSE_REPORT: ["PURCHASE_INVOICE"],
        ZTILL_RECEIPT: ["PURCHASE_INVOICE"],
    };

    banquePatterns = [/banque/];
    achatPatterns = [/achat/, /^ac$/];
    ventePatterns = [/vente/, /^ve$/];
    // socialPatterns = [/social/, /^pa$/, /paie/, /salaire/]
    compteCourantPatterns = [/compte courant/];
    odPatterns = [/op(.)rations{0,1} diverse/, /^od$/, /^ods$/, /^caisse/];
    raPatterns = [/report à nouveau/, /report a nouveau/, /nouveau/];

    bankTypes = [
        "BANK_TRANSACTION",
        "BANK_TRANSACTION & PURCHASE_INVOICE",
        "BANK_TRANSACTION & EXPENSE_REPORT",
        "BANK_TRANSACTION & CURRENT_ACCOUNT",
        "BANK_TRANSACTION & OPERATOR_ACCOUNT",
        "BANK_TRANSACTION & COMMISSION",
        "BANK_TRANSACTION & LOAN",
        "BANK_TRANSACTION & WITH_DELTA",
        "BANK_TRANSACTION & SALES_INVOICE",
        "BANK_TRANSACTION & ZTILL_RECEIPT",
        "BANK_TRANSACTION & MISCELLANEOUS_OPERATION",
    ];

    twoTypesPriorities = [
        {
            priorityType_in: this.bankTypes,
            otherType: "CARRY_FORWARD",
        },
        {
            // logNames: [...this.banquePatterns],
            priorityType: "BANK_TRANSACTION",
            otherType: "MISCELLANEOUS_OPERATION",
        },
        // PURCHASE_INVOICE vs MISCELLANEOUS_OPERATION
        {
            logNames: [...this.achatPatterns],
            priorityType: "PURCHASE_INVOICE",
            otherType: "MISCELLANEOUS_OPERATION",
        },
        {
            logNames: [...this.odPatterns],
            priorityType: "MISCELLANEOUS_OPERATION",
            otherType: "PURCHASE_INVOICE",
        },
        // CURRENT_ACCOUNT vs MISCELLANEOUS_OPERATION
        {
            logNames: [...this.compteCourantPatterns, ...this.achatPatterns],
            priorityType: "CURRENT_ACCOUNT",
            otherType: "MISCELLANEOUS_OPERATION",
        },
        // PAY_SLIP vs MISCELLANEOUS_OPERATION
        // {
        //     // logNames: [...this.socialPatterns],
        //     priorityType: "PAY_SLIP",
        //     otherType: "MISCELLANEOUS_OPERATION"
        // },
        // SALES_INVOICE vs MISCELLANEOUS_OPERATION
        {
            logNames: [...this.ventePatterns],
            priorityType: "SALES_INVOICE",
            otherType: "MISCELLANEOUS_OPERATION",
        },
        {
            logNames: [...this.odPatterns],
            priorityType: "MISCELLANEOUS_OPERATION",
            otherType: "SALES_INVOICE",
        },
        // ZTILL_RECEIPT vs MISCELLANEOUS_OPERATION
        {
            logNames: [...this.ventePatterns],
            priorityType: "ZTILL_RECEIPT",
            otherType: "MISCELLANEOUS_OPERATION",
        },
        // CARRY_FORWARD vs MISCELLANEOUS_OPERATION
        {
            logNames: [...this.raPatterns],
            priorityType: "CARRY_FORWARD",
            otherType: "MISCELLANEOUS_OPERATION",
        },
        {
            logNames: [...this.odPatterns, ...this.achatPatterns, ...this.ventePatterns],
            priorityType: "MISCELLANEOUS_OPERATION",
            otherType: "CARRY_FORWARD",
        },
    ];

    threeTypesPriorities = [
        // CURRENT_ACCOUNT vs MISCELLANEOUS_OPERATION
        {
            logNames: [...this.compteCourantPatterns, ...this.achatPatterns],
            priorityType: "CURRENT_ACCOUNT",
            otherType1: "CARRY_FORWARD",
            otherType2: "MISCELLANEOUS_OPERATION",
        },
        {
            logNames: [...this.odPatterns],
            priorityType: "VAT",
            otherType1: "CARRY_FORWARD",
            otherType2: "MISCELLANEOUS_OPERATION",
        },
        // PURCHASE_INVOICE vs MISCELLANEOUS_OPERATION
        {
            logNames: [...this.achatPatterns],
            priorityType: "PURCHASE_INVOICE",
            otherType1: "CARRY_FORWARD",
            otherType2: "MISCELLANEOUS_OPERATION",
        },
    ];

    // 1-5 : bilan
    // 6 7 resultat

    // 60 : achats                                                                          | PURCHASE_INVOICE
    // 61 : service exterieur                                                               | PURCHASE_INVOICE
    // 62 : autres services exterieur                                                       | PURCHASE_INVOICE

    // 63 : impôt et taxe                                            Opération d'inventaire | MISCELLANEOUS_OPERATION
    // 64 : paie                                                     PAIE                   | PAY_SLIP
    // 65 : autres charges de gestion courante                       OD
    // 66 : financiers intérêts d'emprunt
    //
    // 67 : exeptionnel : facture trésorier                          OD
    // 68 : amortissement et provision                               OD
    // 691 : participation des salariés aux fruits de l’expansion
    // 695 : impot sur les société                                   OD
    // 697 : Imposition forfaitaire annuelle des sociétés
    // 699 : Produits - Report en arrière des déficits

    // users: Array<any>
    // bankAccounts: Array<any>
    // companies: Array<any>
    // blocks: Array<any>

    stat: any;

    keyColumn: string = "EcritureNum";

    // constructor(withAccountingItemImport, repair: boolean = false) {
    //     super(withAccountingItemImport, false, repair)
    //     this.reset();
    //     this.analyseGeneralAAs()
    // }

    reset() {
        this.payslipOnly = false;
        this.sylae = false;
        this.accountableAccounts = [];
        this.journalCodes = [];
        this.bankAccounts = [];
        this.companies = [];
        this.users = [];
        this.salesAccounts = [];
        this.accountingItemImport = null;
        this.accountingPeriod = null;
        // this.resetAccountingItemImport()
        // this.blocks = []
        // this.stat = {
        //     count: {
        //         // blocks: 0,
        //         reconciliated: 0,
        //         autoReconciliate: 0,
        //     }
        // }
        this.logs = [];
    }

    analyseGeneralAAs() {
        // for (const aa in this.generalAccountableAccountTable) {
        for (const aa of this.dbAccountableAccounts) {
            const reducedAA = this.getFirstNonNullNumbers(aa.name);
            if (reducedAA.length > 0 && reducedAA.length < this.generalAAs.length) {
                this.generalAAs[reducedAA.length].push(reducedAA);
            }
        }
        for (const key in this.defaultAccountableAccounts) {
            const reducedAA = this.getFirstNonNullNumbers(key);
            if (reducedAA.length > 0 && reducedAA.length < this.generalAAs.length) {
                if (this.generalAAs[reducedAA.length].indexOf(reducedAA) === -1) {
                    this.generalAAs[reducedAA.length].push(reducedAA);
                }
            }
        }
        // console.log("generalAAs")
        // console.log(this.generalAAs)
    }

    getFirstNonNullNumbers(name): string {
        const result = name.match(pattern);
        if (result && result.length === 2 && result[1].length) {
            const count = name.length - result[1].length;
            if (count > 0 && count <= this.aaCharacterCount) {
                return name.substring(0, count);
            }
        }
        return name;
    }

    reload() {
        this.bankAccounts = [];
        this.companies = [];
        this.users = [];
        this.salesAccounts = [];
    }

    identifySeparator(result) {
        const separators = ["	", "|", ";", ","];
        let bestSeparator;
        let maxCount = 0;
        for (const s of separators) {
            let count = 0;
            for (const c of result) {
                if (c === s) {
                    count++;
                }
            }
            if (!bestSeparator) {
                bestSeparator = s;
                maxCount = count;
            } else if (maxCount < count) {
                bestSeparator = s;
                maxCount = count;
            }
        }
        return bestSeparator;
    }

    csvCleaner(data) {
        if (Object.values(data).join("") === "") {
            return false;
        }
        return true;
    }

    checkFormat(result) {
        if (!result) {
            return false;
        }
        const lines = result.split(/(?:\r\n?|\n)/);
        if (!lines.length) {
            return false;
        }
        const firstLine = lines[0];
        if (firstLine.indexOf("SOLUTIONS INFORMATIQUES") !== -1) {
            return true;
        }
        for (const key in formats) {
            if (key) {
                if (this.check(key, firstLine)) {
                    return true;
                }
            }
        }
        // if (firstLine.indexOf("aaName") !== -1 && firstLine.indexOf("aaWording") !== -1 && firstLine.indexOf("thirdPartyCompany") !== -1) {
        //     return true
        // }
        // JournalCode JournalLib EcritureNum EcritureDate CompteNum CompteLib CompAuxNum CompAuxLib PieceRef PieceDate EcritureLib Debit Credit EcritureLet DateLet ValidDate Montantdevise Idevise
        // const mandatoryWords = ["JournalCode", "JournalLib", "EcritureNum", "EcritureDate", "CompteNum", "CompteLib", "CompAuxNum", "CompAuxLib", "PieceRef", "PieceDate", "EcritureLib", "EcritureLet", "DateLet", "ValidDate"]
        // for (const word of mandatoryWords) {
        //     if (firstLine.indexOf(word) === -1) {
        //         return false
        //     }
        // }
        return true;
    }

    toDate(string: string) {
        const result = moment(string, [
            "DD/MM/YYYY",
            "DD-MM-YYYY",
            "YYYY/MM/DD",
            "YYYY-MM-DD",
            "DDMMYYYY",
        ]);
        if (!result.isValid()) {
            debugger;
        }
        return result;
    }

    async convetCSVToJson(result) {
        const delimiter = this.identifySeparator(result);
        let quote;
        if (delimiter === "|") {
            quote = "off";
        }
        let data = await csvtojson({
            noheader: false,
            trim: true,
            quote,
            delimiter,
        }).fromString(result);
        data = data.filter((x) => this.csvCleaner(x));
        for (const row of data) {
            for (const key in row) {
                row[key] = this.cleanWord(row[key]);
            }
        }
        return data;
    }

    async getAccountingItemImport(accountingItemImportId) {
        return {};
    }

    async getFile(accountingItemImport) {
        const result: any = null;
        return result;
    }

    async getMappingSuggestions(importId: string = undefined) {
        debugger;
        this.mappingSuggestions = {
            accountableAccounts: [],
            bankAccounts: [],
            companies: [],
            users: [],
        };
    }

    async readData(result, file, zipFile, columnMapping = null) {
        let isJson;
        if (file?.name?.toLowerCase().endsWith(".json")) {
            isJson = true;
        } else if (typeof result === "string" && result.startsWith("{") && result.endsWith("}")) {
            isJson = true;
        } else if (typeof result === "object") {
            isJson = true;
        }
        if (isJson) {
            let json;
            if (typeof result === "object") {
                json = result;
            } else {
                json = JSON.parse(result);
            }
            const importSilae = new ImportSilae(json, this.aaCharacterCount);
            if (!importSilae.isSilae) {
                return {
                    error: "Ce fichier n'est pas au format silae",
                    data: [],
                };
            }
            this.importTitle = importSilae.title;
            this.file = file;
            const data = importSilae.importFecData;
            return {
                error: "",
                data,
            };
        }

        this.columnMapping = columnMapping || [];
        let formatResult = result; //.replace(/["]/g, '')
        let lines = formatResult.split(/(?:\r\n?|\n)/);
        lines = lines.map((line) => line.replaceAll(/\0/g, "")); //Delete null unicode characters => utf16
        // lines[0] = lines[0].replace(/[.]/, '')  //If no headers, amounts can be modified incorrectly
        formatResult = lines.join("\n");

        if (file?.name) {
            const values = file.name.split(".");
            this.importTitle = values[0]; //this.file.name.toString().substring(0, file.name.length - 4)
            this.file = file;
        }
        if (zipFile) {
            this.inputData = formatResult;
            this.zipFile = zipFile;
        }

        if (!lines.length) {
            return {
                error: "Le fichier ne contient pas d'écriture comptable",
                data: [],
            };
        }
        const firstLine = lines[0];
        if (firstLine.indexOf("SOLUTIONS INFORMATIQUES") !== -1) {
            return {
                error: "",
                data: this.readPNMFormat(lines),
            };
        }
        const json = await this.convetCSVToJson(formatResult);
        // if(!this.checkDates(json, store)){
        //     return {
        //         error: "Certaines dates sont dans un exercice clos",
        //         data: [],
        //         invalidDates: true
        //     }
        // }
        // if (firstLine.indexOf("aaName") !== -1 && firstLine.indexOf("aaWording") !== -1 && firstLine.indexOf("thirdPartyCompany") !== -1) {
        //     return this.convertBobbeeFormatToFEC(data)
        // }
        const data = [];
        for (const key in formats) {
            if (key) {
                if (this.check(key, firstLine)) {
                    const error = this.readLines(key, json, data);
                    if (!error) {
                        if (key === "bobbee") {
                            this.convertBobbeeFormatToFEC(data);
                        } else if (key === "evoliz") {
                            this.convertEvolizFormatToFEC(data);
                        }
                    } else {
                        return {
                            error,
                            data: [],
                        };
                    }
                }
            }
        }
        if (!data.length) {
            if (columnMapping) {
                return {
                    unknownFormat: true,
                    error: "Format d'import inconnu",
                    data: json,
                    rawData: lines,
                    columnMapping,
                };
            }
            return {
                unknownFormat: true,
                error: "Format d'import inconnu",
                data: json,
                rawData: lines,
                extension: file.name.split(".").pop(),
            };
        }

        return {
            error: "",
            data,
        };
    }

    cleanWord(word) {
        let cw = word.replace(/^ {1,}/, "");
        cw = cw.replace(/ {1,}$/, "");
        if (cw?.startsWith('"')) {
            cw = cw.substring(1);
        }
        if (cw?.endsWith('"')) {
            cw = cw.substring(0, cw.length - 1);
        }
        return cw;
    }

    getHeaders(firstLine) {
        const separator = this.identifySeparator(firstLine);
        if (separator) {
            const headers = firstLine.split(separator);
            for (let i = 0; i < headers.length; i++) {
                headers[i] = this.cleanWord(headers[i]);
            }
            return headers;
        }
        debugger;
        return [];
    }

    check(format, firstLine) {
        const headers = this.getHeaders(firstLine);

        const schema = formats[format];
        for (const column of schema.columns) {
            if (!column.mandatory) {
                continue;
            }
            if (headers.indexOf(column.name) == -1) {
                return false;
            }
        }
        return true;
    }

    filterData(data) {
        const filteredData = [];
        for (const row of data) {
            const amountSigned = this.computeAmountSigned(row);
            if (isAccountingZero(amountSigned)) {
                continue;
            }
            row.amountSigned = amountSigned;
            filteredData.push(row);
        }
        return filteredData;
    }

    checkData(filteredData) {
        //
        // check EcritureNum
        //
        let balance = 0;
        if (filteredData[0].EcritureNum === undefined) {
            let index = 1;
            for (const row of filteredData) {
                row.EcritureNum = index;
                // let amountSigned = row.Debit ? parseFloat(row.Debit.replace(",", ".").replace(/ /g,'')) : 0.0
                // amountSigned -= row.Credit ? parseFloat(row.Credit.replace(",", ".").replace(/ /g,'')) : 0.0
                balance += row.amountSigned;
                if (isAccountingZero(balance)) {
                    index++;
                }
            }
        } else {
            for (const [row, i] of filteredData.entries()) {
                // let amountSigned = row.Debit ? parseFloat(row.Debit.replace(",", ".").replace(/ /g,'')) : 0.0
                // amountSigned -= row.Credit ? parseFloat(row.Credit.replace(",", ".").replace(/ /g,'')) : 0.0
                balance += row.amountSigned;
                if (balance === 0) {
                    row;
                    i;
                    debugger;
                }
            }
        }
        if (!isAccountingZero(balance)) {
            return (
                "Le total du débit est différent du total de crédit. différence= " +
                Math.round(balance * 100) / 100
            );
        }
        return "";
    }

    readLines(format, lines, data) {
        if (!lines.length) {
            debugger; // git-ignore
            return "Le fichier ne contient pas de donnée.";
        }
        // if (format === "fec") {
        //     return lines
        // }

        const schema = formats[format];
        const dicoFECInputFormat = {};
        for (const column of schema.columns) {
            dicoFECInputFormat[column.fec] = column.name;
        }
        for (const line of lines) {
            const row: any = {};
            for (const key in dicoFECInputFormat) {
                const value = line[dicoFECInputFormat[key]];
                if (value) {
                    if (row[key]) {
                        debugger;
                    }
                    row[key] = line[dicoFECInputFormat[key]];
                }
            }

            //
            // post traitment
            //
            if (!row.CompAuxLib) {
                if (row.firstname || row.lastname) {
                    row.CompAuxLib = row.firstname || "";
                    if (row.lastname) {
                        if (row.CompAuxLib) row.CompAuxLib += " ";
                        row.CompAuxLib += row.lastname;
                    }
                } else if (row.user) {
                    row.CompAuxLib = row.user;
                } else if (row.thirdParty) {
                    row.CompAuxLib = row.thirdParty;
                }
            }
            this.convertDates(row);
            data.push(row);
        }
        const filteredData = this.filterData(data);
        if (!filteredData.length) {
            debugger; // git-ignore
            return "Le fichier ne contient pas de donnée comptable";
        }
        return this.checkData(filteredData);
    }

    checkLog() {
        if (!this.data?.length) {
            return;
        }
        if (!this.data[0].JournalCode) {
            if (!this.data[0].JournalLib) {
                for (const row of this.data) {
                    row.JournalCode = "ND";
                }
                for (const row of this.data) {
                    row.JournalLib = "NON DEFINI";
                }
            } else {
                for (const row of this.data) {
                    row.JournalCode = row.JournalLib.substring(0, 2);
                }
            }
        } else if (!this.data[0].JournalLib) {
            for (const row of this.data) {
                row.JournalLib = row.JournalCode;
            }
        }
    }

    convertDates(line) {
        if (line.PieceDate) {
            let pieceDate = line.PieceDate === "19000101" ? line.EcritureDate : line.PieceDate;
            line.PieceDate = this.getDate(pieceDate);
        }
        if (line.EcritureDate) {
            line.EcritureDate = this.getDate(line.EcritureDate);
        }
        if (line.DateLet) {
            line.DateLet = this.getDate(line.DateLet);
        }
        if (line.dueDate) {
            line.dueDate = this.getDate(line.dueDate);
        }
    }

    getDate(date: string) {
        let result = date.match(dateFrPattern);
        if (result && result.length === 4) {
            let fdate = result[3];
            if (result[2].length === 1) {
                fdate += "0";
            }
            fdate += result[2];
            if (result[1].length === 1) {
                fdate += "0";
            }
            fdate += result[1];
            // return result[3]+result[2]+result[1]
            return fdate;
        }
        result = date.match(dateEnPattern);
        if (result && result.length === 4) {
            let fdate = result[1];
            if (result[2].length === 1) {
                fdate += "0";
            }
            fdate += result[2];
            if (result[3].length === 1) {
                fdate += "0";
            }
            fdate += result[3];
            return fdate;
        }
        return date;
    }

    convertEvolizFormatToFEC(data) {
        for (const line of data) {
            if (line.PieceRef) {
                line.EcritureLib += " - ";
                line.EcritureLib += line.PieceRef;
            }
        }
    }

    convertBobbeeFormatToFEC(data) {
        for (const line of data) {
            if (!line.JournalLib && line.type) {
                line.JournalLib = line.type;
            }
        }
    }

    readPNMFormat(lines) {
        if (lines.length < 2) {
            return [];
        }
        const data = [];
        let id = "";
        let log = "";
        for (let index = 1; index < lines.length; index++) {
            const line = lines[index];
            if (!line) {
                continue;
            }
            if (line.length < 103) {
                debugger;
                continue;
            }

            //PA 300621OD421000       X421BU500     PAIE 6/2021  BUNEL, NET A PAYER       S      C             2246,71N                                 EUR
            log = this.cleanWord(line.substring(0, 3));
            id = this.cleanWord(line.substring(3, 11));
            const aa = this.cleanWord(line.substring(11, 24));
            const user = this.cleanWord(line.substring(24, 38));
            const logWording = this.cleanWord(line.substring(38, 42));
            const date = this.cleanWord(line.substring(42, 51));
            const wording = this.cleanWord(line.substring(51, 76));
            // const unknown = this.cleanWord(line.substring(76, 83))
            const debitCredit = this.cleanWord(line.substring(83, 84));
            const amount = this.cleanWord(line.substring(84, 104));
            let CompteLib = aa;
            if (user) {
                CompteLib += " - " + user;
            }
            data.push({
                JournalCode: log,
                JournalLib: logWording,
                EcritureNum: "1",
                EcritureDate: moment(date, "MM/YYYY").endOf("month").format("YYYYMMDD"),
                CompteNum: aa,
                CompteLib,
                CompAuxNum: user || "",
                CompAuxLib: user ? wording : "",
                PieceRef: "",
                PieceDate: "",
                EcritureLib: wording,
                Debit: debitCredit === "D" ? amount : "",
                Credit: debitCredit === "C" ? amount : "",
                EcritureLet: "",
                DateLet: "",
                ValidDate: "",
            });
            // debugger
        }
        return data;
    }

    async setData(
        accountableAccountsData,
        accountingItemImport,
        data,
        payslipOnly = undefined,
        sylae = undefined
    ) {
        this.reset();
        this.aaCharacterCount = accountableAccountsData.aaCharacterCount;
        this.dbAccountableAccounts = accountableAccountsData.dbAccountableAccounts;
        this.inAccountableAccounts = accountableAccountsData.inAccountableAccounts;
        this.defaultAccountableAccounts = accountableAccountsData.defaultAccountableAccounts || {};
        //
        // const defaultAAs = await getDefaultAccountableAccounts()
        //
        this.analyseGeneralAAs();
        await this.getMappingSuggestions();
        //
        this.accountingItemImport = accountingItemImport;
        if (accountingItemImport) {
            this.importTitle = accountingItemImport.name;
        }
        this.data = data;
        if (payslipOnly) {
            this.payslipOnly = payslipOnly;
        }
        if (sylae) {
            this.sylae = sylae;
        }
        if (accountingItemImport && accountingItemImport.accountingPeriod) {
            this.setAccountingPeriod(accountingItemImport.accountingPeriod);
        }
        if (this.accountingItemImport && this.accountingItemImport.data) {
            if (this.accountingItemImport.data.importCarryForward !== undefined) {
                this.importCarryForward = this.accountingItemImport.data.importCarryForward;
            } else {
                this.importCarryForward = false;
            }

            this.useAccountingFirmAccountableAccountMapping =
                this.accountingItemImport.data.useAccountingFirmAccountableAccountMapping || false;

            if (this.accountingItemImport.data.keyColumn !== undefined) {
                this.keyColumn = this.accountingItemImport.data.keyColumn;
            }
        }

        //
        // CompteNum : aaCharacterCount
        //
        for (const row of data) {
            if (row.CompteNum.length !== this.aaCharacterCount) {
                row.CompteNum = row.CompteNum.substring(0, this.aaCharacterCount);
                row.CompteNum = row.CompteNum.padEnd(this.aaCharacterCount, "0");
            }
        }
        //
        // CompteLib : description
        //
        if (this.inAccountableAccounts) {
            for (const row of data) {
                if (!row.CompteLib) {
                    const aa = this.inAccountableAccounts.find((iaa) => iaa.name === row.CompteNum);
                    if (aa) {
                        row.CompteLib = aa.description;
                    }
                }
            }
        }
        //
        // specific case 512
        //
        const dico512 = {};
        // const dicoCompteLibs = []
        // const dicoJournalLibs = []
        // const dicoJournalCodes = []
        // let count = 0
        for (const row of this.data) {
            if (/*!row.CompteLib &&*/ !dico512[row.CompteNum]) {
                if (row.CompteNum?.startsWith("512")) {
                    dico512[row.CompteNum] = {
                        JournalLib: row.JournalLib,
                        JournalCode: row.JournalCode,
                        CompteLib: row.CompteLib,
                    };
                    // count++
                    // if (row.CompteLib && dicoCompteLibs.indexOf(row.CompteLib) === -1) {
                    //     dicoCompteLibs.push(row.CompteLib)
                    // }
                    // if (row.JournalLib && dicoJournalLibs.indexOf(row.JournalLib) === -1) {
                    //     dicoJournalLibs.push(row.JournalLib)
                    // }
                    // if (row.JournalCode && dicoJournalCodes.indexOf(row.JournalCode) === -1) {
                    //     dicoJournalCodes.push(row.JournalCode)
                    // }
                }
            }
        }
        for (const row of this.data) {
            if (!row.CompteLib && row.CompteNum?.startsWith("512")) {
                const data = dico512[row.CompteNum];
                if (data.CompteLib) {
                    row.CompteLib = data.CompteLib;
                } else if (data.JournalLib) {
                    row.CompteLib = data.JournalLib;
                } else if (data.JournalCode) {
                    row.CompteLib = data.JournalCode;
                } else {
                    row.CompteLib = data.CompteNum;
                }
            }
        }
        // if (count) {
        //     if (count === dicoCompteLibs.length) {
        //         for (const row of this.data) {
        //             if (row.CompteNum?.startsWith("512")) {
        //                 row.CompteLib = dico512[row.CompteNum].CompteLib
        //             }
        //         }
        //     } else if (count === dicoJournalLibs.length) {
        //         for (const row of this.data) {
        //             if (row.CompteNum?.startsWith("512")) {
        //                 row.CompteLib = dico512[row.CompteNum].JournalLib
        //             }
        //         }
        //     } else if (count === dicoJournalCodes.length) {
        //         for (const row of this.data) {
        //             if (row.CompteNum?.startsWith("512")) {
        //                 row.CompteLib = dico512[row.CompteNum].JournalCode
        //             }
        //         }
        //     } else {
        //         for (const row of this.data) {
        //             if (!row.CompteLib) {
        //                 if (row.CompteNum?.startsWith("512")) {
        //                     row.CompteLib = row.CompteNum
        //                 }
        //             }
        //         }
        //     }
        // }

        for (const row of this.data) {
            if (row.amount) {
                if (row.debitCredit) {
                    //console.log("____",row.debitCredit, row.debitCredit.toLowerCase())
                    if (row.debitCredit.toLowerCase() === "d") {
                        row.Debit = row.amount;
                    } else if (row.debitCredit.toLowerCase() === "c") {
                        row.Credit = row.amount;
                    } else {
                        debugger;
                    }
                } else {
                    let amount = parseFloat(row.amount);
                    if (amount > 0) {
                        row.Credit = row.amount.toString();
                    } else {
                        row.Debit = row.amount.toString();
                    }
                }
            }
        }

        this.data = this.filterData(this.data);
        if (!this.data.length) {
            debugger; // git-ignore
            return "Le fichier ne contient pas de donnée comptable";
        }

        const result = this.checkData(this.data);
        if (result) {
            return result;
        }

        //
        // accountableAccounts
        //
        await this.computeAccountableAccounts();

        //
        // journalCodes
        //
        // this.computeJournalCodes();
        //
        // specific for sylae fec export : last character on EcritureNum
        //
        if (this.payslipOnly || sylae) {
            let continueCheck = true;
            let baseName = "";
            for (const row of data) {
                console.log(row);
                if (!row) {
                    continue;
                }
                if (row.EcritureNum && (row.EcritureNum + "").length <= 31) {
                    continueCheck = false;
                    break;
                }
                const currentBaseName = (row.EcritureNum + "").substring(0, 31);
                if (!baseName) {
                    baseName = currentBaseName;
                } else if (baseName !== currentBaseName) {
                    continueCheck = false;
                    break;
                }
            }
            if (continueCheck) {
                for (const row of data) {
                    row.EcritureNum = baseName;
                }
                this.sylae = true;
            }
        }
        return "";
    }

    computeBankAccounts() {
        const dicoBAs = {};
        // mapping from previous choice
        if (
            this.accountingItemImport &&
            this.accountingItemImport.data &&
            this.accountingItemImport.data.bankAccounts &&
            this.accountingItemImport.data.bankAccounts.length
        ) {
            for (const ba of this.accountingItemImport.data.bankAccounts) {
                dicoBAs[ba.name] = ba;
            }
            this.accountingItemImport.data.bankAccounts = null;
        }
        // mapping from previous import
        if (this.mappingSuggestions?.bankAccounts?.length) {
            for (const bankAccount of this.mappingSuggestions.bankAccounts) {
                if (!dicoBAs[bankAccount.originalName] && bankAccount.selections?.length) {
                    const selection = bankAccount.selections[0];
                    dicoBAs[bankAccount.originalName] = {
                        id: selection.id,
                        outName: selection.name,
                        name: bankAccount.originalName,
                    };
                }
            }
        }
        for (const ba of this.bankAccounts) {
            if (ba.name && !dicoBAs[ba.name]) {
                dicoBAs[ba.name] = ba;
            }
        }

        //
        this.bankAccounts = [];
        // if (!this.bankAccounts.length) {
        const bankAccountAccountableAccounts = [];
        // const compteNums = this.accountableAccounts;
        for (const compteNum of this.accountableAccounts) {
            // const dbAA = this.dbAccountableAccounts.find(aa => aa.name === compteNum.oss360AAName)
            const foundAA = this.getClosestAccountableAccount(compteNum.oss360AAName);
            if (foundAA && foundAA.bankAccount) {
                bankAccountAccountableAccounts.push(compteNum.name);
            } else if (compteNum.oss360AAName.startsWith("512")) {
                bankAccountAccountableAccounts.push(compteNum.name);
            }
        }

        let result = [];
        result = _.filter(this.data, (x) =>
            _.includes(bankAccountAccountableAccounts, x.CompteNum)
        );
        result = _.uniqBy(result, "CompteLib");
        for (const x of result) {
            const dicoBA = dicoBAs[x.CompteLib];
            if (dicoBA) {
                this.bankAccounts.push({
                    id: dicoBA.id,
                    name: x.CompteLib,
                    outName: dicoBA.outName,
                    balance: 0.0,
                    balanceDate: "",
                    minDate: "",
                    maxDate: "",
                    lastDate: "",
                });
            } else {
                this.bankAccounts.push({
                    id: "",
                    name: x.CompteLib,
                    outName: x.CompteLib,
                    balance: 0.0,
                    balanceDate: "",
                    minDate: "",
                    maxDate: "",
                    lastDate: "",
                });
            }
        }
    }

    getUserName(row) {
        let name = "";
        if (row.firstname || row.lastname) {
            name = row.firstname || "";
            if (row.lastname) {
                if (name) name += " ";
                name += row.lastname;
            }
            return name;
        }
        if (row.CompAuxLib) {
            if (row.CompAuxNum) {
                name = row.CompAuxNum + " - ";
            }
            name += row.CompAuxLib;
        } else if (row.CompAuxNum) {
            name = row.CompAuxNum;
        } else if (row.CompteLib) {
            name = row.CompteLib;
        } else if (row.EcritureLib) {
            name = row.EcritureLib;
        }
        return name;
    }

    computeUsers() {
        const dicoUsers = {};
        // mapping from previous choices
        if (
            this.accountingItemImport &&
            this.accountingItemImport.data &&
            this.accountingItemImport.data.users &&
            this.accountingItemImport.data.users.length
        ) {
            for (const user of this.accountingItemImport.data.users) {
                if (user.id || user.firstname || user.lastname) {
                    dicoUsers[user.name] = user;
                }
            }
            this.accountingItemImport.data.users = null;
        }
        // mapping from previous import
        if (this.mappingSuggestions?.users?.length) {
            for (const user of this.mappingSuggestions.users) {
                if (!dicoUsers[user.originalName] && user.selections?.length) {
                    const selection = user.selections[0];
                    dicoUsers[user.originalName] = selection;
                }
            }
        }
        for (const user of this.users) {
            if (!dicoUsers[user.name]) {
                dicoUsers[user.name] = user;
            }
        }

        this.users = [];
        // if (!this.users.length) {
        // const compteNums = this.accountableAccounts;
        const usersAccountableAccounts = [];
        for (const compteNum of this.accountableAccounts) {
            const foundAA = this.getClosestAccountableAccount(compteNum.oss360AAName);
            // const dbAA = this.dbAccountableAccounts.find(aa => aa.name === compteNum.oss360AAName)
            if (foundAA) {
                if (foundAA.user) {
                    usersAccountableAccounts.push(compteNum.name);
                }
            } else if (compteNum.oss360AAName) {
                debugger;
                console.error(compteNum.oss360AAName);
            }
        }

        let result = [];
        result = _.filter(this.data, (x) => _.includes(usersAccountableAccounts, x.CompteNum));
        for (const row of result) {
            const name = this.getUserName(row);
            // row.userKey = name;
            if (!row.userKey) {
                row.userKey = row.CompteNum + (name ? " - " + name : "");
            }
            // const key = row.userKey || name;
            if (row.userKey) {
                if (!this.users.find((user) => user.key === row.userKey)) {
                    const user = dicoUsers[row.userKey];
                    if (user) {
                        this.users.push({
                            ...user,
                            name,
                            key: row.userKey,
                        });
                    } else {
                        this.users.push({
                            id: "",
                            key: row.userKey,
                            firstname: row.firstname || "",
                            lastname: row.lastname || "",
                            name,
                        });
                    }
                }
            } else {
                debugger;
            }
        }
    }

    getClosestAccountableAccount(aaName) {
        if (!aaName) {
            debugger;
            return null;
        }
        let foundAA = this.closestAccountableAccounts[aaName];
        if (foundAA) {
            return foundAA;
        }
        foundAA = this.dbAccountableAccounts.find((aa) => aa.name === aaName);
        if (foundAA) {
            this.closestAccountableAccounts[aaName] = foundAA;
            return foundAA;
        }
        let count = 6;
        do {
            const reducedAA = aaName.substring(0, count);
            reducedAA.padEnd(6, "0");
            foundAA = this.defaultAccountableAccounts[reducedAA];
            if (foundAA) {
                this.closestAccountableAccounts[aaName] = foundAA;
                return foundAA;
            }
            count--;
        } while (count > 0);

        // debugger;
        console.error("getClosestAccountableAccount not found", aaName);
        return null;
    }

    computeCompanies() {
        const dicoCompanies = {};
        // mapping from previous choices
        if (this.accountingItemImport?.data?.companies?.length) {
            for (const company of this.accountingItemImport.data.companies) {
                if (company?.name) {
                    dicoCompanies[company.name] = company;
                }
            }
            this.accountingItemImport.data.companies = null;
        }
        // mapping from previous import
        if (this.mappingSuggestions?.companies?.length) {
            for (const company of this.mappingSuggestions.companies) {
                if (!dicoCompanies[company.originalName] && company.selections?.length) {
                    const selection = company.selections[0];
                    selection.outName = selection.name;
                    // selection.name = company.originalName;
                    dicoCompanies[company.originalName] = selection;
                }
            }
        }
        //
        // keep previous choice : interactive mode
        //
        for (const company of this.companies) {
            if (company.name && !dicoCompanies[company.name]) {
                dicoCompanies[company.name] = company;
            }
        }

        this.companies = [];

        // identify accountableAccounts require thirdPartyCompany
        const companyAccountableAccounts = [];
        for (const compteNum of this.accountableAccounts) {
            const foundAA = this.getClosestAccountableAccount(compteNum.oss360AAName);
            if (foundAA) {
                if (foundAA.thirdPartyCompany) {
                    companyAccountableAccounts.push(compteNum.name);
                }
            }
        }
        const dicoAAMisc = {};
        if (companyAccountableAccounts.length) {
            let result = _.filter(this.data, (x) =>
                _.includes(companyAccountableAccounts, x.CompteNum)
            );
            // result = _.uniqBy(result, 'CompAuxLib')
            for (const x of result) {
                x.thirdPartyCompanyKey = "";
                let companyName = x.CompAuxLib;
                // if (!companyName) {
                //     companyName = x.EcritureLib
                //     // debugger;
                // }
                if (companyName) {
                    x.thirdPartyCompanyKey += x.CompteNum + " - " + companyName;
                } else {
                    companyName = x.CompteLib || x.CompteNum;
                    dicoAAMisc[x.CompteNum] = companyName;
                    x.thirdPartyCompanyKey = x.CompteNum + (x.CompteLib ? " - " + x.CompteLib : "");
                }

                let company;
                if (x.thirdPartyCompanyKey) {
                    if (!this.companies.find((c) => c.key === x.thirdPartyCompanyKey)) {
                        company = dicoCompanies[x.thirdPartyCompanyKey];
                    }
                }

                if (!company) {
                    // only to retrieve old mapping format based only on companyName
                    company = dicoCompanies[companyName];
                }

                if (company) {
                    this.companies.push({
                        ...company,
                        key: x.thirdPartyCompanyKey,
                        // outName: company.name,
                    });
                } else {
                    this.companies.push({
                        id: null,
                        name: companyName,
                        key: x.thirdPartyCompanyKey,
                        outName: null,
                    });
                }
            }
        }
        for (const row of this.data) {
            if (dicoAAMisc[row.CompteNum] && !row.CompAuxLib) {
                row.CompAuxNum = row.CompteNum;
                row.CompAuxLib = dicoAAMisc[row.CompteNum];
            }
        }
    }

    autoFillCompanies() {
        for (const company of this.companies) {
            if (!company.outName) {
                company.outName = company.name;
                company.id = "";
            }
        }
        // this.companies = this.companies.map((x) => { if (!x.outName) { return { name: x.name, outName: x.name, id: "" } } return x; })
    }

    getCompanyType(company) {
        const companyType = {
            customer: false,
            supplier: false,
        };
        for (const log of this.logs) {
            for (const aaKey of log.aaKeys) {
                for (const transaction of aaKey.transactions) {
                    const r = transaction.rows.find((sr) => sr.CompAuxLib === company);
                    if (!r) {
                        continue;
                    }
                    if (aaKey.type >= 0 && aaKey.type < aaKey.possibleTypes.length) {
                        const t = aaKey.possibleTypes[aaKey.type].type;
                        switch (t) {
                            case "PURCHASE_INVOICE":
                                companyType.supplier = true;
                                return companyType;
                            case "CURRENT_ACCOUNT":
                                companyType.supplier = true;
                                return companyType;
                            case "OPERATOR_ACCOUNT":
                                companyType.supplier = true;
                                return companyType;
                            case "EXPENSE_REPORT":
                                companyType.supplier = true;
                                return companyType;
                            case "SALES_INVOICE":
                                companyType.customer = true;
                                return companyType;
                            case "ZTILL_RECEIPT":
                                companyType.customer = true;
                                return companyType;
                        }
                    }
                    if (r.CompteNum) {
                        const newAA = this.findOSS360AccountableAccount(r.CompteNum);
                        if (newAA) {
                            if (newAA.startsWith("411")) {
                                companyType.customer = true;
                                return companyType;
                            }
                            if (newAA.startsWith("401")) {
                                companyType.supplier = true;
                                return companyType;
                            }
                            debugger;
                        } else {
                            debugger;
                        }
                    } else {
                        debugger;
                    }
                }
            }
        }
        return companyType;
    }

    isType(type, accountableAccounts) {
        const typeRule = this.typeRules[type];
        const mandatories = {};
        if (typeRule && typeRule.mandatory) {
            const mandatoryAccountSet = typeRule.mandatory;
            const maCounters = new Array(mandatoryAccountSet.length).fill(0);

            let counter = 0;
            for (const aa of accountableAccounts) {
                // if (type === "BANK_TRANSACTION" && aa.startsWith("512")) {
                //     debugger
                // }
                let found = false;
                for (const index in mandatoryAccountSet) {
                    if (found) {
                        break;
                    }
                    const mandatoryAccounts = mandatoryAccountSet[index];
                    for (const ma of mandatoryAccounts) {
                        if (aa.match(ma)) {
                            maCounters[index]++;
                            mandatories[aa] = true;
                            found = true;
                            counter++;
                            break;
                        }
                    }
                    if (!found && typeRule.optional) {
                        for (const optionalAA of typeRule.optional) {
                            if (aa.match(optionalAA)) {
                                found = true;
                                counter++;
                                break;
                            }
                        }
                    }
                }
            }
            for (const maCounter of maCounters) {
                if (!maCounter) {
                    return 0;
                }
            }
            // excluded aa
            if (typeRule.excluded) {
                for (const ea of typeRule.excluded) {
                    for (const aa of accountableAccounts) {
                        if (!mandatories[aa] && aa.match(ea)) {
                            return 0;
                        }
                    }
                }
            }
            // if (counter && type === "BANK_TRANSACTION") {
            //     let found
            //     for (const aa of accountableAccounts) {
            //         if (aa.startsWith("512")) {
            //             found = true
            //         }
            //     }
            //     if (!found) {
            //         debugger
            //         this.isType(type, accountableAccounts)

            //     }
            // }
            return counter;
        } else {
            debugger;
        }
        return 0;
    }

    getTypeFromPossibleTypes(logName, possibleTypes) {
        let index;
        if (possibleTypes.length === 2) {
            index = this.getTypeFromTwoPossibleTypes(logName, possibleTypes);
        } else if (possibleTypes.length === 3) {
            index = this.getTypeFromThreePossibleTypes(logName, possibleTypes);
        }
        if (index === undefined) {
            for (let i = 0; i < possibleTypes.length; i++) {
                const pt = possibleTypes[i];
                if (pt.allAAAreMandatory) {
                    if (index !== undefined) {
                        return index;
                    }
                    index = i;
                }
            }
        }
        return index;
    }

    getTypeFromTwoPossibleTypes(logName, possibleTypes) {
        for (const twoTypesPriority of this.twoTypesPriorities) {
            if (twoTypesPriority.logNames) {
                let found = false;
                for (const pattern of twoTypesPriority.logNames) {
                    if (logName.match(pattern)) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    continue;
                }
            }
            let index;
            if (twoTypesPriority.priorityType) {
                index = possibleTypes.findIndex((pt) => pt.type === twoTypesPriority.priorityType);
            } else if (twoTypesPriority.priorityType_in) {
                for (const priorityType of twoTypesPriority.priorityType_in) {
                    index = possibleTypes.findIndex((pt) => pt.type === priorityType);
                    if (index !== -1) {
                        break;
                    }
                }
            } else {
                debugger;
            }

            if (index >= 0 && possibleTypes.find((pt) => pt.type === twoTypesPriority.otherType)) {
                return index;
            }
        }
        return undefined;
    }

    getTypeFromThreePossibleTypes(logName, possibleTypes) {
        for (const threeTypesPriority of this.threeTypesPriorities) {
            if (threeTypesPriority.logNames) {
                let found = false;
                for (const pattern of threeTypesPriority.logNames) {
                    if (logName.match(pattern)) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    continue;
                }
            }
            const index = possibleTypes.findIndex(
                (pt) => pt.type === threeTypesPriority.priorityType
            );
            if (
                index !== -1 &&
                possibleTypes.find((pt) => pt.type === threeTypesPriority.otherType1) &&
                possibleTypes.find((pt) => pt.type === threeTypesPriority.otherType2)
            ) {
                return index;
            }
        }
        return undefined;
    }

    getAccountingItemTypeChoices() {
        const prevLogs = {};
        for (const log of this.logs) {
            const prevLog = {
                aaKeys: {},
                import: log.import,
                importName: log.importName,
            };
            for (const aaKey of log.aaKeys) {
                // const aaKey = log.aaKeys[key];
                if (aaKey.type >= 0 && aaKey.type < aaKey.possibleTypes.length) {
                    prevLog.aaKeys[aaKey.name] = {
                        type: aaKey.possibleTypes[aaKey.type].type,
                    };
                }
            }
            prevLogs[log.shortName] = prevLog;
        }
        return prevLogs;
    }

    addAA(row, transaction) {
        const newAA = this.findOSS360AccountableAccount(row.CompteNum);
        if (newAA) {
            if (!transaction.accountableAccounts.find((aa) => aa === newAA)) {
                transaction.accountableAccounts.push(newAA);
            }
            if (!transaction.accountableAccountCount) {
                transaction.accountableAccountCount = {};
            }
            if (!transaction.accountableAccountCount[newAA]) {
                transaction.accountableAccountCount[newAA] = 1;
            } else {
                transaction.accountableAccountCount[newAA]++;
            }
            // else {
            //     console.log("already push aa=  " + newAA);
            // }
        } else {
            debugger;
        }
    }

    computeTransactions() {
        const logs = {};
        let transactionIndex = 0;
        const transactions = [];
        this.checkLog();
        this.totalDebitCredit = 0;
        for (const row of this.data) {
            let log = logs[row.JournalCode];
            if (!log) {
                log = {
                    shortName: row.JournalCode,
                    name: row.JournalLib,
                    aaKeys: {},
                    transactions: {},
                };
                if (row.type) {
                    log.type = row.type;
                }
                logs[row.JournalCode] = log;
            }
            let transaction = log.transactions[row[this.keyColumn]];
            if (!transaction) {
                transaction = {
                    log: row.JournalCode,
                    // key: row[this.keyColumn],
                    wording: row[this.keyColumn] + " - " + row.EcritureLib,
                    aaKey: "",
                    accountableAccounts: [],
                    accountableAccountCount: {},
                    rows: [],
                    index: transactionIndex,
                    total: 0.0,
                    zeros: [],
                };
                if (row.type) {
                    transaction.inputType = row.type;
                }
                transactionIndex++;
                log.transactions[row[this.keyColumn]] = transaction;
                transactions.push(transaction);
            }
            transaction.rows.push(row);
            if (row.CompteNum?.startsWith("129") || row.CompteNum?.startsWith("120")) {
                transaction.isCarryForward = true;
            }

            const debitS = row.Debit ? row.Debit.replace(",", ".").replace(/ /g, "") : "";
            const creditS = row.Credit ? row.Credit.replace(",", ".").replace(/ /g, "") : "";
            let debit = 0.0;
            let credit = 0.0;
            if (debitS) {
                if (!this.checkAmount(debitS)) {
                    debugger;
                } else {
                    debit = parseFloat(debitS);
                }
            }
            if (creditS) {
                if (!this.checkAmount(creditS)) {
                    debugger;
                } else {
                    credit = parseFloat(creditS);
                }
            }
            this.totalDebitCredit += debit - credit;
            transaction.total += debit - credit;
            if (isAccountingZero(transaction.total)) {
                transaction.zeros.push(transaction.rows.length);
            }
        }
        if (isAccountingZero(this.totalDebitCredit)) {
            this.totalDebitCredit = 0;
        }
        //
        // split transactions if necessary
        //
        for (let ti = 0; ti < transactions.length; ti++) {
            const transaction = transactions[ti];
            if (!transaction.isCarryForward && transaction.zeros.length >= 2) {
                // let sameDate = true
                // let start = 0
                // for (let z = 0; z < transaction.zeros.length; z++) {
                //     const end = transaction.zeros[z]
                //     for (let ri = start + 1; ri < end; ri++) {
                //         if (transaction.rows[ri].PieceDate !== transaction.rows[start].PieceDate) {
                //             sameDate = false
                //             break;
                //         }
                //     }
                //     start = end
                // }

                // if (sameDate) {
                const toDeleteIndices = [];
                let start = transaction.zeros[0];
                for (let z = 1; z < transaction.zeros.length; z++) {
                    const end = transaction.zeros[z];
                    const firstRow = transaction.rows[start];
                    const newEcritureNum =
                        firstRow[this.keyColumn] + "_" + (transactionIndex + 1).toString();
                    const newTransaction = {
                        log: firstRow.JournalCode,
                        wording: newEcritureNum + " - " + firstRow.EcritureLib,
                        aaKey: "",
                        accountableAccounts: [],
                        accountableAccountCount: {},
                        rows: [],
                        index: transactionIndex,
                        total: 0.0,
                        zeros: [],
                    };
                    for (let ri = start; ri < end; ri++) {
                        const row = transaction.rows[ri];
                        row[this.keyColumn] = newEcritureNum;
                        newTransaction.rows.push(row);
                        // this.addAA(row, newTransaction)
                        toDeleteIndices.push(ri);
                    }
                    transaction.accountableAccounts = [];
                    for (const row of transaction.rows) {
                        // this.addAA(row, transaction)
                    }

                    transactionIndex++;
                    const log = logs[newTransaction.log];
                    log.transactions[newEcritureNum] = newTransaction;

                    start = end;
                }
                toDeleteIndices.sort((a, b) => {
                    if (a < b) return 1;
                    if (a > b) return -1;
                    return 0;
                });
                for (const indice of toDeleteIndices) {
                    transaction.rows.splice(indice, 1);
                }
                // }
            }
        }

        if (this.keyColumn === "EcritureNum") {
            //
            // merge two sequential transactions if necessary
            //
            // for (let ti = 1; ti < transactions.length; ti++) {
            //     const transaction = transactions[ti];
            //     if (!isAccountingZero(transaction.total)) {
            //         const prevTransaction = transactions[ti - 1]
            //         if (prevTransaction.log === transaction.log) {
            //             if (!isAccountingZero(prevTransaction.total) && isAccountingZero(prevTransaction.total + transaction.total)) {
            //                 prevTransaction.total = 0
            //                 const prevEcritureNum = prevTransaction.rows[0].EcritureNum
            //                 const EcritureNum = transaction.rows[0].EcritureNum
            //                 const newKey = prevEcritureNum + "_" + EcritureNum
            //                 prevTransaction.rows.push(...transaction.rows)
            //                 for (const row of prevTransaction.rows) {
            //                     row.EcritureNum = newKey
            //                 }
            //                 const log = logs[transaction.log]
            //                 log.transactions[prevEcritureNum] = undefined
            //                 log.transactions[newKey] = prevTransaction
            //                 delete log.transactions[EcritureNum]
            //                 ti++
            //             }
            //         } else {
            //             debugger
            //         }
            //     }
            // }
            //
            // merge sequential transactions if necessary
            //
            for (let ti = 0; ti < transactions.length; ti++) {
                const transaction = transactions[ti];
                transaction.notBalanced = false;
                if (!isAccountingZero(transaction.total)) {
                    transaction.notBalanced = true;
                    let total = transaction.total;
                    let ti1 = ti + 1;
                    let found = false;
                    for (; ti1 < transactions.length; ti1++) {
                        const nextTransaction = transactions[ti1];
                        if (nextTransaction.log === transaction.log) {
                            if (!isAccountingZero(nextTransaction.total)) {
                                nextTransaction.notBalanced = true;
                                total += nextTransaction.total;
                                if (isAccountingZero(total)) {
                                    found = true;
                                    transaction.total = 0;
                                    const EcritureNum = transaction.rows[0].EcritureNum;
                                    const NewEcritureNum =
                                        transaction.rows[0].EcritureNum +
                                        "_MergedWithNext" +
                                        (ti1 - ti + 1).toString();

                                    const log = logs[transaction.log];

                                    for (let mti = ti + 1; mti <= ti1; mti++) {
                                        const toMergeTransaction = transactions[mti];
                                        transaction.rows.push(...toMergeTransaction.rows);
                                        delete log.transactions[
                                            toMergeTransaction.rows[0].EcritureNum
                                        ];
                                    }
                                    for (const row of transaction.rows) {
                                        row.EcritureNum = NewEcritureNum;
                                    }

                                    log.transactions[NewEcritureNum] = transaction;
                                    log.transactions[EcritureNum] = undefined;

                                    ti = ti1 + 1;
                                }
                            } else {
                                ti = ti1 + 1;
                                break;
                            }
                        } else {
                            ti = ti1;
                            break;
                        }
                    }
                    if (ti1 === transactions.length) {
                        ti = ti1;
                    }
                }
            }
        }
        return logs;
    }

    analyseAccountingTransactions() {
        this.computeBankAccounts();
        this.computeCompanies();
        this.computeUsers();
        //
        this.logs = [];
        this.totalDebitCredit = 0;

        const logs = this.computeTransactions();

        for (const logKey in logs) {
            const log = logs[logKey];
            for (const tKey in log.transactions) {
                const transaction = log.transactions[tKey];
                if (transaction) {
                    for (const row of transaction.rows) {
                        this.addAA(row, transaction);
                    }
                } else {
                    debugger;
                }
            }
        }

        //
        // analyse type
        //
        for (const logKey in logs) {
            const log = logs[logKey];
            if (!log) {
                continue;
            }
            for (const tKey in log.transactions) {
                const transaction = log.transactions[tKey];
                if (!transaction) {
                    debugger;
                    continue;
                }
                transaction.accountableAccounts.sort((a, b) => {
                    if (a < b) return -1;
                    if (a > b) return 1;
                    return 0;
                });
                for (const aa of transaction.accountableAccounts) {
                    if (transaction.aaKey) transaction.aaKey += " | ";
                    transaction.aaKey += aa || "";
                }
                if (transaction.type) {
                    transaction.aaKey += " - " + transaction.type;
                }
                let aaKey = log.aaKeys[transaction.aaKey];
                if (aaKey) {
                    aaKey.transactions.push(transaction);
                    if (transaction.inputType && transaction.inputType !== aaKey.inputType) {
                        debugger;
                    }
                } else {
                    // create aaKey
                    aaKey = {
                        name: transaction.aaKey,
                        accountableAccounts: transaction.accountableAccounts,
                        accountableAccountCount: transaction.accountableAccountCount,
                        possibleTypes: [],
                        type: transaction.type || undefined,
                        transactions: [transaction],
                    };
                    if (transaction.inputType) {
                        aaKey.inputType = transaction.inputType;
                    }
                    log.aaKeys[transaction.aaKey] = aaKey;
                }
            }
            //
            // necessary condition
            //
            // for (const key in log.aaKeys) {
            //     const aaKey = log.aaKeys[key];
            //     for (const aa of aaKey.accountableAccounts) {
            //         const rule = this.rules.accountableAccounts[aa]
            //         if (rule) {
            //             aaKey.possibleTypes = _.intersection(aaKey.possibleTypes, rule.types)

            //         } else {
            //             debugger;
            //             console.error("analyseAccountingTransactions no rule for aa = "+aa)
            //         }
            //     }
            // }
            //
            // sufficient condition
            //
            for (const key in log.aaKeys) {
                const aaKey = log.aaKeys[key];
                for (const type in this.typeRules) {
                    const count = this.isType(type, aaKey.accountableAccounts);
                    if (count) {
                        // if (type === "CARRY_FORWARD") {
                        //     this.isType(type, aaKey.accountableAccounts);
                        // }
                        aaKey.possibleTypes.push({
                            type,
                            allAAAreMandatory: count >= aaKey.accountableAccounts.length,
                            disabled: false,
                        });
                    }
                }
                aaKey.possibleTypes.push({
                    type: "MISCELLANEOUS_OPERATION",
                    disabled: false,
                });
            }
            //
            // all Accounts
            //
            // for (const key in log.aaKeys) {
            //     const aaKey = log.aaKeys[key];
            //     for (const type in this.allAccounts) {
            //         const allAccounts = this.allAccounts[type];

            //         let add = true;
            //         for (const aa of aaKey.accountableAccounts) {
            //             if (!aa.match(allAccounts)) {
            //                 add = false;
            //                 break;
            //             }
            //         }
            //         if (add) {
            //             if (!aaKey.possibleTypes.find(pt => pt.type === type)) {
            //                 aaKey.possibleTypes.push({
            //                     type,
            //                     disabled: false
            //                 })
            //             }
            //         } else {
            //             const index = aaKey.possibleTypes.findIndex(pt => pt.type === type);
            //             if (index !== -1) {
            //                 aaKey.possibleTypes.splice(index, 1)
            //             }
            //         }
            //     }
            // }
            //
            // priority types
            //
            for (const key in log.aaKeys) {
                const aaKey = log.aaKeys[key];
                if (aaKey.possibleTypes.length > 1) {
                    for (let ti = 0; ti < aaKey.possibleTypes.length; ti++) {
                        const type = aaKey.possibleTypes[ti].type;
                        const otherTypes = this.priorityTypes[type];
                        const dicoToRemoveTypes = {};
                        if (otherTypes) {
                            for (let oti = aaKey.possibleTypes.length - 1; oti >= 0; oti--) {
                                if (oti === ti || dicoToRemoveTypes[oti] !== undefined) {
                                    continue;
                                }
                                const otherType = aaKey.possibleTypes[oti].type;
                                if (otherTypes.indexOf(otherType) !== -1) {
                                    dicoToRemoveTypes[oti] = oti;
                                }
                            }
                        }
                        const toRemoveTypes = Object.values(dicoToRemoveTypes);
                        if (toRemoveTypes.length) {
                            toRemoveTypes.sort((a, b) => {
                                if (a < b) return 1;
                                if (a > b) return -1;
                                return 0;
                            });
                            for (const tIndex of toRemoveTypes) {
                                aaKey.possibleTypes.splice(tIndex, 1);
                            }
                        }
                    }
                }
            }
            //
            // cash accounting detection
            //
            // for (const key in log.aaKeys) {
            // const aaKey = log.aaKeys[key];
            // let bankTransactionIndex
            // let otherIndexes = []
            // let cashBoxIndex
            // if (aaKey.possibleTypes.length >= 2) {
            //     for (let ti = 0; ti < aaKey.possibleTypes.length; ti++) {
            //         const type = aaKey.possibleTypes[ti].type
            // if (type === "CARRY_FORWARD") {
            //     carryForwardIndex = ti
            // }
            // else
            // if (type === "BANK_TRANSACTION") {
            //     aaKey.possibleTypes = [aaKey.possibleTypes[ti]]
            //     break
            //     // bankTransactionIndex = ti
            // }
            // else if (type === "CASH_BOX") {
            //     cashBoxIndex = ti
            // }
            // else if (type === "PURCHASE_INVOICE" ||
            //     type === "EXPENSE_REPORT" ||
            //     type === "CURRENT_ACCOUNT" ||
            //     type === "OPERATOR_ACCOUNT" ||
            //     type === "PAY_SLIP" ||
            //     type === "SALES_INVOICE" ||
            //     type === "ZTILL_RECEIPT" ||
            //     type === "MISCELLANEOUS_OPERATION") {
            //     otherIndexes.push(ti)
            // }
            // }
            // }
            //
            // BANK_TRANSACTION AND LOAN OR COMMISSION OR WITHDELTA
            //
            // const thirdPartyAAs = [/^4550/, /^4551/, /^108/, /^511[0-9]/, /^580[0-9]/, /^4/]
            // let loanOrCommissionOrWithDeltaFound = false
            // let btCount = 0
            // if (bankTransactionIndex !== undefined && otherIndexes.length && aaKey.possibleTypes[bankTransactionIndex].type === "BANK_TRANSACTION") {
            //     let loan = 0
            //     let withDelta = 0
            //     let commission = 0
            //     // let otherTypeForLoan = 0

            //     const withDeltaAAs = ["658000", "758000"]
            //     const loanAAs = ["661000", "661100", "616000", "164000"]
            //     // const commissionAAs = ["627100", "627200", "627800", "445660"];
            //     // loanAAs.push(...commissionAAs)
            //     btCount = aaKey.accountableAccountCount["512000"]

            //     for (const aa of aaKey.accountableAccounts) {
            //         // if (aa === "512000") {
            //         //     btCount = aaKey.accountableAccountCount[aa]
            //         // }
            //         if (this.isType("BANK_TRANSACTION", [aa])) {

            //             continue
            //         }
            //         // if (aa !== "445660") {
            //         //     let thirdPartyFound = false
            //         //     for (const forbiddenAA of thirdPartyAAs) {
            //         //         if (aa.match(forbiddenAA)) {
            //         //             otherTypeForLoan++
            //         //             thirdPartyFound = true
            //         //             break;
            //         //         }
            //         //     }

            //         //     if (thirdPartyFound) {
            //         //         continue;
            //         //     }
            //         // }

            //         if (loanAAs.indexOf(aa) !== -1 || aa.startsWith("661")) {
            //             loan++
            //         } else if (this.commissionAAs.indexOf(aa) !== -1) {
            //             commission++
            //         } else if (withDeltaAAs.indexOf(aa) !== -1) {
            //             withDelta++
            //         } else {
            //             loan = 0
            //             commission = 0
            //             // otherTypeForLoan = 0
            //             withDelta = 0
            //             break;
            //         }
            //     }
            //     if (btCount > 1) {
            //         loan = 0
            //         commission = 0
            //         withDelta = 0
            //     }
            //     // if (otherTypeForLoan && loan) {
            //     //     loan = 0
            //     //     commission = 0
            //     // }
            //     //
            //     // do not change order
            //     //
            //     if (loan) {
            //         aaKey.possibleTypes[bankTransactionIndex].type += " & LOAN"
            //         for (let i = otherIndexes.length - 1; i >= 0; i--) {
            //             aaKey.possibleTypes.splice(otherIndexes[i], 1);
            //         }
            //         otherIndexes = []
            //         loanOrCommissionOrWithDeltaFound = true
            //     } else if (commission) {
            //         aaKey.possibleTypes[bankTransactionIndex].type += " & COMMISSION"
            //         for (let i = otherIndexes.length - 1; i >= 0; i--) {
            //             aaKey.possibleTypes.splice(otherIndexes[i], 1);
            //         }
            //         otherIndexes = []
            //         loanOrCommissionOrWithDeltaFound = true
            //     } else if (withDelta) {
            //         aaKey.possibleTypes[bankTransactionIndex].type += " & WITH_DELTA"
            //         for (let i = otherIndexes.length - 1; i >= 0; i--) {
            //             aaKey.possibleTypes.splice(otherIndexes[i], 1);
            //         }
            //         otherIndexes = []
            //         loanOrCommissionOrWithDeltaFound = true
            //     }
            // }
            // //
            // // BANK_TRANSACTION|CASH_BOX AND OTHER TYPE
            // //
            // // if (bankTransactionIndex !== undefined && cashBoxIndex !== undefined) {
            // //     aaKey.possibleTypes[bankTransactionIndex].type = aaKey.possibleTypes[bankTransactionIndex].type + " & " + aaKey.possibleTypes[cashBoxIndex].type
            // //     aaKey.possibleTypes.splice(cashBoxIndex, 1);
            // // } else
            // if (!loanOrCommissionOrWithDeltaFound && (bankTransactionIndex !== undefined /*|| cashBoxIndex !== undefined*/) && otherIndexes.length) {
            //     // bankTransactionIndex = bankTransactionIndex !== undefined ? bankTransactionIndex : cashBoxIndex
            //     // hack for 455000 & 512000 to avoid combination : BANK_TRANSACTION & MISCELLANEOUS_OPERATION
            //     let combine = true;

            //     if (otherIndexes.length === 1 && aaKey.possibleTypes[otherIndexes[0]].type === "MISCELLANEOUS_OPERATION") {
            //         // if (btCount === 1) {
            //         if (aaKey.accountableAccounts.length === 1) {
            //             aaKey.possibleTypes.splice(otherIndexes[0], 1);
            //             combine = false
            //         } else if (aaKey.accountableAccounts.length === 2) {
            //             let aa
            //             if (this.isType("BANK_TRANSACTION", [aaKey.accountableAccounts[0]])) {
            //                 aa = aaKey.accountableAccounts[1];
            //             } else {
            //                 aa = aaKey.accountableAccounts[0];
            //             }
            //             for (const forbiddenAA of thirdPartyAAs) {
            //                 if (aa.match(forbiddenAA)) {
            //                     combine = false
            //                     aaKey.possibleTypes.splice(otherIndexes[0], 1);
            //                 }
            //             }
            //         }
            //         // } else {
            //         //     combine = false
            //         //     aaKey.possibleTypes.splice(bankTransactionIndex, 1);
            //         // }
            //     }
            //     if (combine) {
            //         for (const otherIndex of otherIndexes) {
            //             aaKey.possibleTypes[otherIndex].type = aaKey.possibleTypes[bankTransactionIndex].type + " & " + aaKey.possibleTypes[otherIndex].type
            //         }
            //         aaKey.possibleTypes.splice(bankTransactionIndex, 1);
            //     }
            // }
            // }
        }
        //
        // type
        //
        // keep previous choice
        let prevLogs;
        if (
            this.accountingItemImport &&
            this.accountingItemImport.data &&
            this.accountingItemImport.data.logs
        ) {
            for (const key in this.accountingItemImport.data.logs) {
                if (key) {
                    prevLogs = this.accountingItemImport.data.logs;
                    this.accountingItemImport.logs = null;
                    break;
                }
            }
        }
        if (!prevLogs) {
            prevLogs = this.getAccountingItemTypeChoices();
        }
        for (const logKey in logs) {
            const log = logs[logKey];
            if (!log) {
                debugger; // git-ignore
                continue;
            }
            const prevLog = prevLogs[log.shortName];
            const logNameTLC = log.name.toLowerCase();
            const oLog = {
                shortName: log.shortName,
                name: log.name,
                aaKeys: [],
                // transactions: [],
                types: [],
                selectedTypes: [],
                count: 0,
                import: prevLog ? prevLog.import : false,
                importName: prevLog ? prevLog.importName : log.name,
            };
            // let types = []
            for (const key in log.aaKeys) {
                console.log(key);

                const aaKey = log.aaKeys[key];
                console.log(aaKey);
                if (aaKey.possibleTypes.length === 1) {
                    aaKey.type = 0;
                } else if (aaKey.inputType) {
                    const typeIndex = aaKey.possibleTypes.findIndex(
                        (pt) => pt.type === aaKey.inputType
                    );
                    if (typeIndex >= 0) {
                        aaKey.type = typeIndex;
                    } else if (aaKey.inputType === "MISCELLANEOUS_OPERATION") {
                        aaKey.type = aaKey.possibleTypes.length;
                        aaKey.possibleTypes.push({ type: aaKey.inputType, disabled: false });
                    } else {
                        throw new Error("Access error");
                    }
                } else {
                    if (prevLog) {
                        const prevAAKey = prevLog.aaKeys[key];
                        if (prevAAKey && prevAAKey.type) {
                            const index = aaKey.possibleTypes.findIndex(
                                (pt) => pt.type === prevAAKey.type
                            );
                            if (index >= 0) {
                                aaKey.type = index;
                            }
                        }
                    }
                    if (aaKey.type === undefined) {
                        aaKey.type = this.getTypeFromPossibleTypes(logNameTLC, aaKey.possibleTypes);
                    }
                }

                aaKey.showDetails = false;
                oLog.aaKeys.push(aaKey);
                oLog.types = _.union(
                    oLog.types,
                    aaKey.possibleTypes.map((t) => t.type)
                );
                oLog.count += aaKey.transactions.length;
            }

            for (let index = 0; index < oLog.types.length; index++) {
                oLog.selectedTypes.push(index);
            }
            this.logs.push(oLog);
        }
    }

    identifyTag(aa) {
        if (!aa) {
            debugger;
            return;
        }
        // 1-5 =>  compte auxiliaire (user, company)
        //     437 => sociaux
        //     165 => dépot de garantie
        //     275 dépot et cautionnement
        // 6-7 => Tag
        if (!aa.name || !aa.oss360AAName) {
            aa.tagType = 0;
            aa.tag = "";
            aa.disabledTag = true;
            // debugger;
            return;
        }
        // const rule = this.rules.accountableAccounts[aa.oss360AAName];
        // if (rule && rule.thirdParty) {
        //     aa.tagType = 0
        //     aa.tag = ""
        //     aa.disabledTag = true
        //     return
        // }
        // if (aa.oss360AAName.startsWith("108") || aa.oss360AAName.startsWith("455") || aa.oss360AAName.startsWith("580") || aa.oss360AAName.startsWith("511")) {
        //     aa.tagType = 0
        //     aa.tag = ""
        //     aa.disabledTag = true
        //     return
        // }
        aa.disabledTag = false;

        if (aa.oss360AAName.startsWith("512")) {
            aa.disabledTag = true;
        }

        if (!aa.tag) {
            // const original = this.getFirstNonNullNumbers(aa.name);
            // const oss360 = this.getFirstNonNullNumbers(aa.oss360AAName);
            // if (original !== oss360) {
            aa.tag = aa.desc || aa.name;
            // }
        }
        if (aa.tag && !aa.tagType) {
            if (aa.oss360AAName.startsWith("164")) {
                aa.tagType = 2;
            }
            // else {
            //     aa.tagType = 1
            // }
        }

        // const dbAA = this.dbAccountableAccounts.find(dbaa => dbaa.name === aa.oss360AAName)
        // if (dbAA?.subAccountableAccountOf) {
        //     aa.tagType = 0
        //     // aa.tag = ""
        //     aa.disabledTag = true
        // }
    }

    // getAAWithVAT(wording, prefix) {
    //     let oss360Name
    //     if (wording.match(/20/)) {
    //         oss360Name = prefix + "20"
    //     } else if (wording.match(/10/)) {
    //         oss360Name = prefix + "10"
    //     } else if (wording.match(/5[\.,]5/)) {
    //         oss360Name = prefix + "05"
    //     } else if (wording.match(/2[\.,]1/)) {
    //         oss360Name = prefix + "02"
    //     } else if (wording.match(/8[\.,]5/)) {
    //         oss360Name = prefix + "08"
    //     } else if (wording.match(/19[\.,]6/)) {
    //         oss360Name = prefix + "00"
    //     } else if (wording.match(/hors champs/)) {
    //         oss360Name = prefix + "00"
    //     } else if (wording.match(/intracom/) || wording.match(/ ue /) || wording.match(/ ue$/)) {
    //         oss360Name = prefix + "30"
    //     } else if (wording.match(/export/)) {
    //         oss360Name = prefix + "80"
    //     } else if (wording.match(/exoner[eé]/)) {
    //         oss360Name = prefix + "00"
    //     }
    //     return oss360Name
    // }

    getAAWithVAT(wording, prefix, vatAAs: any[]) {
        let oss360Name;
        if (vatAAs) {
            if (wording.match(/20/)) {
                oss360Name = getAANameFromVatRate(vatAAs, prefix, 20);
            } else if (wording.match(/10/)) {
                oss360Name = getAANameFromVatRate(vatAAs, prefix, 10);
            } else if (wording.match(/5[\.,]5/)) {
                oss360Name = getAANameFromVatRate(vatAAs, prefix, 5.5);
            } else if (wording.match(/2[\.,]1/)) {
                oss360Name = getAANameFromVatRate(vatAAs, prefix, 2.1);
            } else if (wording.match(/8[\.,]5/)) {
                oss360Name = getAANameFromVatRate(vatAAs, prefix, 8.5);
            } else if (wording.match(/19[\.,]6/)) {
                oss360Name = getAANameFromVatType(vatAAs, prefix, "NO_VAT_TYPE");
            } else if (wording.match(/hors champs/)) {
                oss360Name = getAANameFromVatType(vatAAs, prefix, "NO_VAT_TYPE");
            } else if (
                wording.match(/intracom/) ||
                wording.match(/ ue /) ||
                wording.match(/ ue$/)
            ) {
                oss360Name = getAANameFromVatType(vatAAs, prefix, "INTRACOM");
            } else if (wording.match(/export/)) {
                oss360Name = getAANameFromVatType(vatAAs, prefix, "EXPORT");
            } else if (wording.match(/exoner[eé]/)) {
                oss360Name = getAANameFromVatType(vatAAs, prefix, "NO_VAT_TYPE");
            }
        } else {
            oss360Name = prefix + "00";
        }
        return oss360Name;
    }

    // getAAWithPurchaseVAT(aaName, wording, prefix) {
    //     let oss360Name
    //     if (wording.match(/20/)) {
    //         oss360Name = prefix + "0"
    //     } else if (wording.match(/10/)) {
    //         oss360Name = prefix + "0"
    //     } else if (wording.match(/5[\.,]5/)) {
    //         oss360Name = prefix + "0"
    //     } else if (wording.match(/2[\.,]1/)) {
    //         oss360Name = prefix + "0"
    //     } else if (wording.match(/8[\.,]5/)) {
    //         oss360Name = prefix + "0"
    //     } else if (wording.match(/19[\.,]6/)) {
    //         oss360Name = prefix + "0"
    //     } else if (aaName.startsWith("445660") || wording.match(/autre/)) {
    //         oss360Name = prefix + "0"
    //     } else if (wording.match(/intracom/) || wording.match(/ ue /) || wording.match(/ ue$/)) {
    //         oss360Name = prefix + "2"
    //     } else {
    //         oss360Name = prefix + "0"
    //     }
    //     return oss360Name
    // }

    getAAWithPurchaseVAT(aaName, wording, prefix, vatAAs: any[]) {
        let oss360Name;
        let defaultDedVatAAName = "";
        if (vatAAs) {
            defaultDedVatAAName = getDefaultDedVatAAName(vatAAs);
            if (wording.match(/20/)) {
                oss360Name = defaultDedVatAAName;
            } else if (wording.match(/10/)) {
                oss360Name = defaultDedVatAAName;
            } else if (wording.match(/5[\.,]5/)) {
                oss360Name = defaultDedVatAAName;
            } else if (wording.match(/2[\.,]1/)) {
                oss360Name = defaultDedVatAAName;
            } else if (wording.match(/8[\.,]5/)) {
                oss360Name = defaultDedVatAAName;
            } else if (wording.match(/19[\.,]6/)) {
                oss360Name = defaultDedVatAAName;
            } else if (aaName.startsWith("445660") || wording.match(/autre/)) {
                oss360Name = defaultDedVatAAName;
            } else if (
                wording.match(/intracom/) ||
                wording.match(/ ue /) ||
                wording.match(/ ue$/)
            ) {
                oss360Name = getDefaultPurchasesIntracomDedVatAAName(vatAAs);
            } else {
                oss360Name = defaultDedVatAAName;
            }
        } else {
            oss360Name = prefix + "0";
        }
        return oss360Name;
    }

    async searchAAfromWording(eaa, cmpt) {
        let oss360Name;

        if (cmpt.desc) {
            const wording = cmpt.desc.toLowerCase() || "";
            // console.log(wording)
            let vatAAs: any[] = [];
            if (this.companyId) {
                vatAAs = await this.getVatAAsQuery();
            }
            if (eaa.startsWith("445")) {
                if (eaa === "44566") {
                    oss360Name = this.getAAWithPurchaseVAT(cmpt.name, wording, eaa, vatAAs);
                } else if (eaa === "4457") {
                    oss360Name = this.getAAWithVAT(wording, eaa, vatAAs);
                }
                if (!oss360Name) {
                    if (
                        wording.match(/ autoliq/) &&
                        wording?.match(/ due /) &&
                        wording.match(/tva/)
                    ) {
                        // oss360Name = "445780"
                        oss360Name = getDefaultPurchasesReverseChargeCollVatAAName(vatAAs);
                    } else if (
                        wording.match(/ autoliq/) &&
                        wording?.match(/ ded/) &&
                        wording.match(/tva/)
                    ) {
                        // oss360Name = "445680"
                        oss360Name = getDefaultPurchasesReverseChargeDedVatAAName(vatAAs);
                    } else if (
                        cmpt.name.startsWith("4456") &&
                        wording?.match(/ immo/) &&
                        wording.match(/tva/)
                    ) {
                        // oss360Name = "445620"
                        oss360Name = getDefaultFixedAssetsVatAAName(vatAAs);
                    }
                }
            } else if (eaa === "70") {
                if (cmpt.name) {
                    const prefix = cmpt.name.substring(0, 3) + "0";
                    oss360Name = this.getAAWithVAT(wording, prefix, vatAAs);
                }
                if (!oss360Name) {
                    if (cmpt.name.startsWith("708")) {
                        if (cmpt.name.startsWith("708100")) {
                            oss360Name = "708100";
                        } else if (cmpt.name.startsWith("708200")) {
                            oss360Name = "708200";
                        } else if (cmpt.name.startsWith("708300")) {
                            oss360Name = "708300";
                        } else if (cmpt.name.startsWith("708400")) {
                            oss360Name = "708400";
                        } else if (cmpt.name.startsWith("708500")) {
                            oss360Name = "708500";
                        } else if (cmpt.name.startsWith("708600")) {
                            oss360Name = "708600";
                        } else if (cmpt.name.startsWith("708700")) {
                            oss360Name = "708700";
                        } else if (cmpt.name.startsWith("708800")) {
                            oss360Name = "708800";
                        }
                    }
                }
            } else if (eaa === "511" || eaa === "580") {
                oss360Name = eaa;
                if (wording?.match(/esp.ce/) || wording?.match(/journali.re/)) {
                    oss360Name += "100";
                } else if (wording?.match(/vacance/)) {
                    oss360Name += "141";
                } else if (wording?.match(/ch.que/) || wording?.match(/chq/)) {
                    oss360Name += "110";
                } else if (
                    wording.match(/cb/) ||
                    wording?.match(/amex/) ||
                    (wording?.match(/carte/) &&
                        (wording?.match(/bleue/) ||
                            wording?.match(/bancaire/) ||
                            wording?.match(/cr.dit/)))
                ) {
                    oss360Name += "120";
                } else if (wording?.match(/virement/)) {
                    oss360Name += "130";
                } else if (
                    wording?.match(/restaurant/) ||
                    wording?.match(/resto/) ||
                    wording?.match(/ tr/)
                ) {
                    oss360Name += "140";
                } else if (wording?.match(/paypal/)) {
                    oss360Name += "150";
                } else if (wording?.match(/uber/) || wording?.match(/deliveroo/)) {
                    oss360Name += "160";
                } else if (eaa === "511" && wording?.match(/valeurs{0,1} . l.encaissement/)) {
                    oss360Name = "511000";
                }
            }
            // else if (eaa === "437") {
            //     // const mutuellePrevoyances = [
            //     //     /malakoff/,
            //     //     /mederic/,

            //     // ]
            //     if (wording?.match(/autres{0,1} organismes{0,1} sociaux{0,1}/)) {
            //         oss360Name = "437000"
            //     } else if (wording?.match(/retraite/) || wording?.match(/irpc/)) {
            //         oss360Name = "437300"
            //     } else if (wording?.match(/mutuelle/)) {
            //         if (wording?.match(/pr.voy/)) {
            //             oss360Name = "437500"
            //         } else {
            //             oss360Name = "437520"
            //         }
            //     } else if (wording?.match(/pr.voy/)) {
            //         oss360Name = "437510"
            //     } else if (wording?.match(/resto/) || wording?.match(/restaurant/)) {
            //         oss360Name = "437800"
            //     } else if (wording?.match(/rsi/)) {
            //         oss360Name = "437700"
            //     } else if (wording?.match(/ci btp/)) {
            //         oss360Name = "437550"
            //     } else if (wording?.match(/smi/)) {
            //         oss360Name = "437520"
            //     }
            // }
        }

        return oss360Name
            ? this.dbAccountableAccounts.find((x) => x.name === oss360Name)
            : undefined;
    }

    searchAAFromWording2(cmpt) {
        let oss360Name;
        if (cmpt.name.startsWith("607")) {
            const wording = cmpt?.desc?.toLowerCase() || "";
            if (wording) {
                if (wording.match(/liquide/)) {
                    oss360Name = "607100";
                } else if (wording.match(/solide/)) {
                    oss360Name = "607200";
                }
            }
        }
        return oss360Name
            ? this.dbAccountableAccounts.find((x) => x.name === oss360Name)
            : undefined;
    }

    applyOSS360AA(cmpt, accountableAccount) {
        if (accountableAccount) {
            cmpt.oss360AAName = accountableAccount.name;
            cmpt.isGeneral = this.isGeneralAccountableAccount(accountableAccount.name);
            if (cmpt.isGeneral) {
                cmpt.validated = true;
            }
            this.identifyTag(cmpt);
        }
    }

    async computeAccountableAccounts() {
        this.accountableAccounts = _.uniqBy(this.data, "CompteNum").map((x) => ({
            name: x.CompteNum,
            desc: x.CompteLib,
            wordings: [],
            oss360AAName: null,
            isGeneral: false,
            fromAFMapping: false,
            validated: false,
            tagType: 0,
            tag: "",
            disabledTag: true,
            // isGeneral: x.CompteNum.endsWith('000')
        }));
        for (const row of this.data) {
            const faa = this.accountableAccounts.find((aa) => aa.name === row.CompteNum);
            if (faa) {
                if (faa.wordings.indexOf(row.EcritureLib) === -1) {
                    faa.wordings.push(row.EcritureLib);
                }
            }
        }

        _.orderBy(this.accountableAccounts, ["name"]);

        // DO NOT CHANGE ORDER
        // const excludedAAs = ["44566", "4457", "445", "70", "580", "511", "437"]
        const excludedAAs = ["44566", "4457", "445", "70", "580", "511"];
        //
        // link
        //
        for (const cmpt of this.accountableAccounts) {
            if (cmpt.name) {
                // mapping from previous choice (at accounting firm choices level)
                if (
                    this.accountingItemImport &&
                    this.accountingItemImport.data &&
                    this.accountingItemImport.data.accountableAccountMapping
                ) {
                    const mapping =
                        this.accountingItemImport.data.accountableAccountMapping[cmpt.name];
                    if (
                        mapping /*&& !!this.dbAccountableAccounts.find(aa => aa.name ===  mapping.accountableAccount)*/
                    ) {
                        cmpt.oss360AAName = mapping.accountableAccount;
                        cmpt.validated = true;
                        cmpt.isGeneral = this.isGeneralAccountableAccount(cmpt.oss360AAName);
                        if (this.useAccountingFirmAccountableAccountMapping) {
                            const aam = this.accountingFirmAccountableAccountMappings[cmpt.name];
                            if (aam && aam.accountableAccount.name === cmpt.oss360AAName) {
                                cmpt.fromAFMapping = true;
                            }
                        }
                        if (mapping.tag && mapping.tagType) {
                            cmpt.tag = mapping.tag;
                            cmpt.tagType = mapping.tagType;
                        }
                        this.identifyTag(cmpt);
                        continue;
                    }
                }
                // mapping from previous import (at company level)
                if (this.mappingSuggestions?.accountableAccounts?.length) {
                    const aaSuggestion = this.mappingSuggestions.accountableAccounts.find(
                        (aa) => aa.originalName === cmpt.name
                    );
                    if (aaSuggestion?.selections?.length) {
                        const selection = aaSuggestion.selections[0];
                        if (
                            selection.accountableAccount &&
                            !!this.dbAccountableAccounts.find(
                                (aa) => aa.name === selection.accountableAccount
                            )
                        ) {
                            cmpt.oss360AAName = selection.accountableAccount;
                            cmpt.validated = true;
                            cmpt.isGeneral = this.isGeneralAccountableAccount(cmpt.oss360AAName);
                            if (selection.tag && selection.tagType) {
                                cmpt.tag = selection.tag;
                                cmpt.tagType = selection.tagType;
                            }
                            this.identifyTag(cmpt);
                            continue;
                        }
                    }
                }
                if (cmpt.name?.toLowerCase().startsWith("c")) {
                    const dbaa = this.dbAccountableAccounts.find((aa) =>
                        aa.name?.startsWith("411000")
                    );
                    if (dbaa) {
                        cmpt.oss360AAName = dbaa.name;
                        cmpt.validated = true;
                        cmpt.isGeneral = this.isGeneralAccountableAccount(cmpt.oss360AAName);
                        this.identifyTag(cmpt);
                    } else {
                        debugger; // git-ignore
                    }
                    continue;
                }
                if (cmpt.name?.toLowerCase().startsWith("f")) {
                    const dbaa = this.dbAccountableAccounts.find((aa) =>
                        aa.name?.startsWith("401000")
                    );
                    if (dbaa) {
                        cmpt.oss360AAName = dbaa.name;
                        cmpt.validated = true;
                        cmpt.isGeneral = this.isGeneralAccountableAccount(cmpt.oss360AAName);
                        this.identifyTag(cmpt);
                    } else {
                        debugger; // git-ignore
                    }
                    continue;
                }
                // standard behavior
                //
                let aaName = getRootName(cmpt.name);
                if (cmpt.name.startsWith("512")) {
                    aaName = "512";
                }
                if (aaName.length < this.aaCharacterCount) {
                    while (aaName.length < this.aaCharacterCount) {
                        aaName += "0";
                    }
                }
                let acc = this.dbAccountableAccounts.find(
                    (x) =>
                        x.name === aaName &&
                        x.description?.toLowerCase() === cmpt.desc?.toLowerCase()
                );
                if (acc && acc.id) {
                    cmpt.oss360AAName = acc.name;
                    cmpt.isGeneral = this.isGeneralAccountableAccount(acc.name);
                    if (cmpt.isGeneral) {
                        cmpt.validated = true;
                    }
                    this.identifyTag(cmpt);
                } else if (!acc) {
                    let excluded = false;
                    for (const eaa of excludedAAs) {
                        if (aaName.startsWith(eaa)) {
                            const accountableAccount = await this.searchAAfromWording(eaa, cmpt);
                            this.applyOSS360AA(cmpt, accountableAccount);
                            excluded = true;
                            break;
                        }
                    }
                    if (excluded) {
                        continue;
                    }
                }

                // if (this.useAccountingFirmAccountableAccountMapping) {
                //     const aam = this.accountingFirmAccountableAccountMappings[cmpt.name]
                //     if (aam) {
                //         acc = aam.accountableAccount
                //         cmpt.oss360AAName = acc.name
                //         cmpt.isGeneral = this.isGeneralAccountableAccount(acc.name)
                //         cmpt.fromAFMapping = true
                //         cmpt.validated = true
                //         this.identifyTag(cmpt);
                //     }
                // }
                if (!acc) {
                    acc = this.dbAccountableAccounts.find((x) => x.name === aaName);
                    if (acc && acc.id) {
                        cmpt.oss360AAName = acc.name;
                        cmpt.isGeneral = this.isGeneralAccountableAccount(acc.name);
                        if (cmpt.isGeneral) {
                            cmpt.validated = true;
                        }
                        this.identifyTag(cmpt);
                    } else {
                        let reducedAA = this.getFirstNonNullNumbers(aaName);
                        if (reducedAA.length >= this.generalAAs.length) {
                            reducedAA = reducedAA.substring(0, this.generalAAs.length - 1);
                        }
                        for (let count = reducedAA.length; count > 0; count--) {
                            if (reducedAA) {
                                if (!this.generalAAs[count]) {
                                    console.error(
                                        "count greater than this.generalAAs.length",
                                        count,
                                        " > ",
                                        this.generalAAs.length
                                    );
                                    continue;
                                }
                                const result = this.generalAAs[count].filter(
                                    (aa) => aa === reducedAA
                                );
                                if (result && result.length) {
                                    let foundAA = result[0];
                                    const dbAA = foundAA;
                                    dbAA.padEnd(this.aaCharacterCount, "0");
                                    let facc = this.dbAccountableAccounts.find(
                                        (x) => x.name === dbAA
                                    );
                                    if (!facc) {
                                        const defaultAA = dbAA.padEnd(6, "0");
                                        facc = this.defaultAccountableAccounts[defaultAA];
                                    }
                                    if (facc) {
                                        cmpt.oss360AAName = facc.name.padEnd(
                                            this.aaCharacterCount,
                                            "0"
                                        );
                                        cmpt.validated = !!this.toValidateAAs.find((aa) =>
                                            cmpt.oss360AAName.startsWith(aa)
                                        );

                                        this.identifyTag(cmpt);
                                        break;
                                    } else if (!this.forceAAIfNotFound) {
                                        console.error("ERROR missing general aa= " + foundAA);
                                        break;
                                    }
                                }
                                reducedAA = reducedAA.substring(0, reducedAA.length - 1);
                            } else {
                                debugger;
                                break;
                            }
                        }
                        if (!cmpt.oss360AAName) {
                            const accountableAccount = this.searchAAFromWording2(cmpt);
                            this.applyOSS360AA(cmpt, accountableAccount);
                        }
                    }
                }
            } else {
                debugger;
            }
        }
        // this.computeSalesAAsFromAmount()
        this.accountableAccounts.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });
    }

    computeAmountSigned(row) {
        if (!this.checkAmount(row.Debit) && !this.checkAmount(row.Credit)) {
            return 0;
        }
        let d = 0;
        let c = 0;
        if (row.Debit) {
            d = parseFloat(row.Debit.replace(",", ".").replace(/ /g, ""));
        }
        if (row.Credit) {
            c = parseFloat(row.Credit.replace(",", ".").replace(/ /g, ""));
        }
        return d - c;
    }

    // computeSalesAAsFromAmount() {
    //     const dicoAAs = {}
    //     let counter = 0
    //     for (const cmpt of this.accountableAccounts) {
    //         if (cmpt.name) {
    //             if (cmpt.name.startsWith("70") || cmpt.name.startsWith("4457")) {
    //                 if (!cmpt.oss360AAName) {
    //                     counter++
    //                 }
    //                 dicoAAs[cmpt.name] = cmpt
    //             }
    //         }
    //     }
    //     if (!counter) {
    //         return
    //     }
    //     const logs = this.computeTransactions()
    //     for (const logKey in logs) {
    //         const log = logs[logKey];
    //         for (const tKey in log.transactions) {
    //             const transaction = log.transactions[tKey];
    //             if (!transaction) {
    //                 debugger
    //                 continue
    //             }

    //             const row70s = []
    //             const row457s = []
    //             const row411s = []
    //             for (const row of transaction.rows) {
    //                 // 445720 | 511120 | 531000 | 707020
    //                 if (row.CompteNum.startsWith("70")) {
    //                     row70s.push(row)
    //                 } else if (row.CompteNum.startsWith("411") || row.CompteNum.startsWith("511") || row.CompteNum.startsWith("531") || row.CompteNum.startsWith("530")) {
    //                     row411s.push(row)
    //                 } else if (row.CompteNum.startsWith("4457")) {
    //                     row457s.push(row)
    //                 } else {
    //                     break;
    //                 }
    //             }
    //             if ((row70s.length + row457s.length + row411s.length) !== transaction.rows.length) {
    //                 continue
    //             }
    //             if (row70s.length !== 1 || !row411s.length || row457s.length > 1) {
    //                 continue
    //             }
    //             const row70 = row70s[0]

    //             if (!row457s.length) {
    //                 if (dicoAAs[row70.CompteNum].oss360AAName) {
    //                     continue
    //                 }
    //                 const netAmountSigned = this.computeAmountSigned(row70)
    //                 let grossAmountSigned = 0;
    //                 for (const row411 of row411s) {
    //                     grossAmountSigned += this.computeAmountSigned(row411)
    //                 }
    //                 if (isAccountingZero(netAmountSigned - grossAmountSigned)) {
    //                     const oss360Name = row70.CompteNum.substring(0, 4) + "00"
    //                     const accountableAccount = this.dbAccountableAccounts.find(x => x.name === oss360Name)
    //                     this.applyOSS360AA(dicoAAs[row70.CompteNum], accountableAccount)
    //                 }

    //             } else {
    //                 const row457 = row457s[0]
    //                 //
    //                 if (dicoAAs[row70.CompteNum].oss360AAName && dicoAAs[row457.CompteNum].oss360AAName) {
    //                     continue
    //                 } else if (dicoAAs[row70.CompteNum].oss360AAName && !dicoAAs[row457.CompteNum].oss360AAName) {
    //                     const suffix = dicoAAs[row70.CompteNum].oss360AAName.substring(4)
    //                     const oss360Name = "4457" + suffix
    //                     const accountableAccount = this.dbAccountableAccounts.find(x => x.name === oss360Name)
    //                     this.applyOSS360AA(dicoAAs[row457.CompteNum], accountableAccount)

    //                 } else if (!dicoAAs[row70.CompteNum].oss360AAName && dicoAAs[row457.CompteNum].oss360AAName) {
    //                     const suffix = dicoAAs[row457.CompteNum].oss360AAName.substring(4)
    //                     const oss360Name = row70.CompteNum.substring(0, 3) + "0" + suffix
    //                     const accountableAccount = this.dbAccountableAccounts.find(x => x.name === oss360Name)
    //                     this.applyOSS360AA(dicoAAs[row70.CompteNum], accountableAccount)

    //                 } else {
    //                     const netAmountSigned = this.computeAmountSigned(row70)
    //                     const vatAmountSigned = this.computeAmountSigned(row457)
    //                     if (vatAmountSigned && vatAmountSigned) {
    //                         const vatRate = vatAmountSigned / netAmountSigned
    //                         for (const candidateVatRate of vatRates) {
    //                             if (isAccountingZero(candidateVatRate - vatRate)) {
    //                                 const suffix = getVatRateSuffix(candidateVatRate)
    //                                 let cmpt = dicoAAs[row70.CompteNum]
    //                                 let oss360Name = row70.CompteNum.substring(0, 3) + "0" + suffix
    //                                 let accountableAccount = this.dbAccountableAccounts.find(x => x.name === oss360Name)
    //                                 this.applyOSS360AA(cmpt, accountableAccount)

    //                                 cmpt = dicoAAs[row457.CompteNum]
    //                                 oss360Name = "4457" + suffix
    //                                 accountableAccount = this.dbAccountableAccounts.find(x => x.name === oss360Name)
    //                                 this.applyOSS360AA(cmpt, accountableAccount)
    //                                 break;
    //                             }
    //                         }
    //                     }
    //                 }

    //             }
    //         }
    //     }
    // }

    accountableAccountsFilled() {
        for (const acc of this.accountableAccounts) {
            if (!acc.oss360AAName) {
                return false;
            }
        }
        return true;
    }

    /** ENGINE */

    compute() {
        // let blocks = this.blockDistribution(this.data)
        // blocks = Object.values(blocks)
        // blocks = blocks.map((x) => {
        //     // debugger
        //     const accBlock = this.getOpportTypesFromFEC(x)
        //     return {
        //         lines: x,
        //         compatibleTypes: accBlock,
        //         type: accBlock.length === 1 ? accBlock[0] : ""
        //     }
        // })
        // this.blocks = blocks
        // return this.blocks
        this.translateAccountingItems();
    }

    findOSS360AccountableAccount(account) {
        const trueAccount = this.accountableAccounts.find((x) => x.name === account);
        if (!trueAccount) {
            debugger;
            return "";
        }
        // if (!trueAccount.oss360AAName) debugger;
        return trueAccount.oss360AAName;
    }

    translateAccountingItems() {
        this.accountingItems = [];
        const dicoAccountingItems = {};
        // const blocks = this.blocks.filter( b => b.type !== "")
        let index = 0;
        // for (const block of this.blocks) {
        //     for (const row of block.lines) {
        for (const log of this.logs) {
            for (const aaKey of log.aaKeys) {
                const type = aaKey.possibleTypes[aaKey.type].type;
                //
                // group tag at accounting item level if tag is the same for each transaction
                //
                for (const transaction of aaKey.transactions) {
                    let tags = [];
                    if (type.indexOf("BANK_TRANSACTION") === -1) {
                        // tag grouping
                        for (let i = 1; i <= 4; i++) {
                            const tagKey = "tag" + i.toString();
                            let maintTag;
                            for (const transactionRow of transaction.rows) {
                                const tag = transactionRow[tagKey];
                                if (tag) {
                                    if (!maintTag) {
                                        maintTag = tag;
                                    } else if (maintTag !== tag) {
                                        maintTag = undefined;
                                        break;
                                    }
                                } else {
                                    maintTag = undefined;
                                    break;
                                }
                            }
                            if (maintTag) {
                                if (!tags) {
                                    tags = [];
                                }
                                tags.push(maintTag);
                                for (const transactionRow of transaction.rows) {
                                    delete transactionRow[tagKey];
                                }
                            }
                        }
                    }
                    //
                    // create row
                    //
                    for (const transactionRow of transaction.rows) {
                        let id = "";
                        if (!transactionRow.JournalCode) {
                            id = "XXX";
                            debugger;
                        } else {
                            id = transactionRow.JournalCode;
                        }
                        id += "_";
                        if (!transactionRow[this.keyColumn]) {
                            id += "XXX";
                            debugger;
                        } else {
                            id += transactionRow[this.keyColumn];
                        }

                        // const id = transactionRow[this.keyColumn] || "ORPHELIN";
                        const row = {
                            id: id,
                            index: index++,
                            type,
                            wording: transactionRow.EcritureLib,
                            logCode: transactionRow.JournalCode,
                            originalAccountableAccount: transactionRow.CompteNum,
                            accountableAccount: undefined,
                            ecritureDate: transactionRow.EcritureDate,
                            date: transactionRow.PieceDate || transactionRow.EcritureDate || null,
                            itemReference: transactionRow.PieceRef,
                            debit: transactionRow.Debit
                                ? transactionRow.Debit.replace(",", ".").replace(/ /g, "")
                                : "",
                            credit: transactionRow.Credit
                                ? transactionRow.Credit.replace(",", ".").replace(/ /g, "")
                                : "",
                            dueDate: transactionRow.dueDate || null,
                            // reconciliation: !!transactionRow.EcritureLet,
                            lettering: transactionRow.EcritureLet,
                            result: {
                                debit: 0.0,
                                credit: 0.0,
                            },
                            otherAttributes: {},
                            url: transactionRow.url,
                            fileName: transactionRow.fileName,
                            tags: undefined,
                        };
                        index++;
                        // row = { ...row, ...this.findThirdParty(transactionRow) }

                        const accountableAccount = this.findOSS360AccountableAccount(
                            transactionRow.CompteNum
                        );
                        if (accountableAccount) {
                            row.accountableAccount = accountableAccount;
                        } else {
                            debugger;
                        }
                        //
                        // tag
                        //
                        for (let i = 1; i <= 4; i++) {
                            const tag = transactionRow["tag" + i.toString()];
                            if (tag) {
                                if (!row.tags) {
                                    row.tags = [];
                                }
                                row.tags.push(tag);
                            }
                        }

                        const accountingItem = this.addRowToAccountingItem(
                            dicoAccountingItems,
                            row,
                            transaction.index,
                            tags
                        );
                        this.analyseThirdParty(accountingItem, row, transactionRow);
                        this.identifySalesAccounts(row.accountableAccount.name);
                        // debugger
                    }
                }
            }
        }

        this.accountingItems.sort((ai1, ai2) => {
            if (ai1.transactionIndex < ai2.transactionIndex) return -1;
            if (ai1.transactionIndex > ai2.transactionIndex) return 1;
            return 0;
        });

        for (const accountingItem of this.accountingItems) {
            this.analyseAccountingItem(accountingItem);
        }
        // create result debit/credit before reduce()
        this.analyseAllRowErrors();
        this.reduce();
        // this.computeReconciliations();
        // this.computeVAT();
        // this.computeCarryForwards();
        // debugger
        // return this.accountingItems;
    }

    // generalLedger = []
    generalLedgerWithThirdParty = false;

    get generalLedger() {
        const output = {};

        for (const accountingItem of this.accountingItems) {
            for (const row of accountingItem.rows) {
                let accountableAccount = this.dbAccountableAccounts.find(
                    (x) => x.name === row.accountableAccount
                );
                if (!accountableAccount) {
                    const name = this.accountableAccounts.find(
                        (aa) => aa.oss360AAName === row.accountableAccount
                    ).desc;
                    const description =
                        String(name).charAt(0).toUpperCase() + String(name).slice(1).toLowerCase();
                    accountableAccount = {
                        name: row.accountableAccount || "XXXXX",
                        description: description || "Xxxxx xxxxxx",
                    };
                }
                if (accountableAccount) {
                    let key = accountableAccount.name;
                    // if (this.generalLedgerWithThirdParty && (!key.startsWith("40") && !key.startsWith("41"))) {
                    //     continue
                    // }

                    let name = accountableAccount.name;
                    if (this.generalLedgerWithThirdParty) {
                        if (!name.startsWith("512") && row.thirdParty) {
                            key += " - " + row.thirdParty;
                            name += " - " + row.thirdParty;
                        } else {
                            continue;
                        }
                    }
                    let ai = output[key];
                    if (!ai) {
                        ai = {
                            key: key,
                            name: name,
                            description: this.generalLedgerWithThirdParty
                                ? row.thirdParty
                                : accountableAccount.description,
                            accountingTransactions: [],
                            totalDebit: 0.0,
                            totalCredit: 0.0,
                        };
                        if (this.generalLedgerWithThirdParty) {
                            ai.unletteredTotal = 0.0;
                            ai.letteredTotal = 0.0;
                        }
                        output[key] = ai;
                    }
                    const item: any = {
                        log: row.type,
                        number: row.id,
                        // thirdParty: row.compAuxNum,
                        date: row.date ? moment(row.date, "YYYYMMDD").format("YYYY-MM-DD") : "",
                        wording: row.wording,
                        debit: row.result.debit,
                        credit: row.result.credit,
                        balance: 0.0,
                        // object: row.object
                        // reconciliation: ,
                        // vatDeclaration: 0
                        lettering: row.lettering,
                    };
                    ai.totalDebit += item.debit;
                    ai.totalCredit += item.credit;
                    if (this.generalLedgerWithThirdParty) {
                        if (row.lettering) {
                            ai.letteredTotal += item.debit - item.credit;
                        } else {
                            ai.unletteredTotal += item.debit - item.credit;
                        }
                    }
                    ai.accountingTransactions.push(item);
                } else {
                    debugger;
                }
            }
        }
        if (this.generalLedgerWithThirdParty) {
            for (const aa in output) {
                const aats = output[aa];
                const total = aats.totalDebit - aats.totalCredit;
                if (isAccountingZero(total)) {
                    if (!isAccountingZero(aats.unletteredTotal)) {
                        aats.error = "Soldé mais pas complètement lettré";
                    }
                } else if (!isAccountingZero(total - aats.unletteredTotal)) {
                    aats.error =
                        "Différence entre le solde et non lettrés  = " +
                        formatCurrency(total - aats.unletteredTotal);
                }
            }
        }
        const generalLedger = [];
        for (const aa in output) {
            const aats = output[aa];
            aats.accountingTransactions.sort((a, b) => {
                if (a.date < b.date) return -1;
                if (a.date > b.date) return 1;
                return 0;
            });
            let balance = 0.0;
            for (const aat of aats.accountingTransactions) {
                balance += aat.debit - aat.credit;
                aat.balance = balance;
            }
            generalLedger.push(aats);
        }
        generalLedger.sort((a, b) => {
            if (a.key < b.key) return -1;
            if (a.key > b.key) return 1;
            return 0;
        });

        return generalLedger;
        // return {
        //     generalLedger: generalLedger,
        //     errors: []
        // }
    }

    analyseThirdParty(accountingItem, row, transactionRow) {
        //
        // thirdParty
        //
        // const rule = this.rules.accountableAccounts[row.accountableAccount];
        const dbAA = this.dbAccountableAccounts.find((aa) => aa.name === row.accountableAccount);
        const addBankAccount = dbAA?.bankAccount || row.accountableAccount.startsWith("512");
        if (dbAA && (dbAA.user || dbAA.thirdPartyCompany || addBankAccount)) {
            // if (!row.thirdParty) {
            //     accountingItem.errorCount++;
            //     row.thirdPartyError = "thirdParty missing";
            // } else
            if (addBankAccount) {
                if (!transactionRow.CompteLib) {
                    accountingItem.errorCount++;
                    row.thirdPartyError = "bankAccount missing";
                } else {
                    row.thirdParty = transactionRow.CompteLib;
                    row.bankAccount = transactionRow.CompteLib;
                    if (!accountingItem.bankAccounts) {
                        accountingItem.bankAccounts = [];
                    }
                    if (accountingItem.bankAccounts.indexOf(row.bankAccount) === -1) {
                        accountingItem.bankAccounts.push(row.bankAccount);
                    }
                }
            } else if (dbAA.user) {
                const userName = this.getUserName(transactionRow);
                if (!userName) {
                    accountingItem.errorCount++;
                    row.thirdPartyError = "user missing";
                } else {
                    row.thirdParty = userName;
                    row.user = userName;
                    row.userKey = transactionRow.userKey;
                }
            } else if (dbAA.thirdPartyCompany) {
                if (!transactionRow.CompAuxLib) {
                    accountingItem.errorCount++;
                    row.thirdPartyError = "company missing";
                } else {
                    row.thirdParty = transactionRow.CompAuxLib;
                    row.thirdPartyCompany = transactionRow.CompAuxLib;
                    row.thirdPartyCompanyKey = transactionRow.thirdPartyCompanyKey;
                }
            } else {
                debugger;
            }
        }
    }

    /* RECONCILIATION */

    // getReconciliatedCompany() {
    // }

    // reconciliationCompanies() {
    //     const companyLines = this.data.filter(x => this.isInCompany(x.CompAuxLib))
    //     const companies = _.groupBy(companyLines, "CompAuxLib")
    //     let companiesList = Object.keys(companies)
    //     const reconcilitedCompanies = []
    //     for(let c of companiesList){
    //         console.table(companies[c].map(x => x.Credit))
    //         let credit = companies[c].reduce((a, b) => {
    //             if(!isNaN(parseInt(a)) && !isNaN(parseInt(b.Credit)) ){
    //                 return parseInt(a) + parseInt(b.Credit)
    //             }
    //             return 0
    //         }, 0)
    //         let debit = companies[c].reduce((a, b) => {
    //             if(!isNaN(parseInt(a)) && !isNaN(parseInt(b.Debit)) ){
    //                 return parseInt(a) + parseInt(b.Debit)
    //             }
    //             return 0
    //         }, 0)
    //         if (credit === debit) reconcilitedCompanies.push(c)
    //     }
    //     console.table(companiesList)
    //     console.table(reconcilitedCompanies)
    //     debugger
    // }

    isInCompany(label) {
        const index = this.companies.findIndex((x) => x.name === label);
        return !(index === -1);
    }

    async upsertAccountingItemImport(companyId) {
        if (!this.isEditable) {
            return;
        }
        if (!this.withAccountingItemImport) {
            // debugger;
            return;
        }
        let data: any;
        // let newAccountingFirmAccountableAccountMappings
        if (this.accountingItemImport && this.accountingItemImport.data) {
            data = JSON.parse(JSON.stringify(this.accountingItemImport.data));
        }
        if (this.importCarryForward !== null) {
            if (!data) {
                data = {};
            }
            data.importCarryForward = this.importCarryForward;
        }
        if (this.useAccountingFirmAccountableAccountMapping) {
            if (!data) {
                data = {};
            }
            data.useAccountingFirmAccountableAccountMapping =
                this.useAccountingFirmAccountableAccountMapping;
        }
        if (this.keyColumn !== null) {
            if (!data) {
                data = {};
            }
            data.keyColumn = this.keyColumn;
        }
        if (this.accountableAccounts) {
            if (!data) {
                data = {};
            }
            data.accountableAccountMapping = {};
            for (const aa of this.accountableAccounts) {
                if (!aa.name || !aa.oss360AAName) {
                    // debugger;
                    continue;
                }
                const aaMappging: any = {
                    originalDescription: aa.desc,
                    accountableAccount: aa.oss360AAName,
                };
                if (!aa.disabledTag && aa.tagType) {
                    if (aa.tag !== undefined) {
                        aaMappging.tag = aa.tag;
                        aaMappging.tagType = aa.tagType;
                    }
                }
                data.accountableAccountMapping[aa.name] = aaMappging;
            }
        }
        if (this.logs) {
            if (!data) {
                data = {};
            }
            data.logs = this.getAccountingItemTypeChoices();
        }
        if (this.bankAccounts.length) {
            if (!data) {
                data = {};
            }
            data.bankAccounts = this.bankAccounts;
        }

        if (this.users.length) {
            if (!data) {
                data = {};
            }
            data.users = this.users;
        }

        if (this.companies.length) {
            if (!data) {
                data = {};
            }
            data.companies = this.companies;
        }

        if (this.inAccountableAccounts && this.inAccountableAccounts.length) {
            if (!data) {
                data = {};
            }
            data.inAccountableAccounts = this.inAccountableAccounts;
        }
        if (this.columnMapping && this.columnMapping.length) {
            if (!data) {
                data = {};
            }
            data.columnMapping = this.columnMapping;
        }

        return await this.upsertAccItemImportEnd(data, companyId);
    }

    async upsertAccItemImportEnd(data, companyId) {}
}
